(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["JOIN-COMMUNITY"]) return;
  try {
    
  (function () {
    class FooterPersonalizado extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.iniciarObservadorVisibilidad();
      }

      iniciarObservadorVisibilidad() {
        const activarSiVisible = () => {
          const rect = this.getBoundingClientRect();
          const visible = rect.top < window.innerHeight && rect.bottom > 0;
          if (visible) {
            this.classList.add('seccion-visible');
          }
        };

        activarSiVisible();

        if (!('IntersectionObserver' in window)) {
          this.classList.add('seccion-visible');
          return;
        }

        const observador = new IntersectionObserver((entradas) => {
          entradas.forEach((entrada) => {
            if (entrada.isIntersecting) {
              this.classList.add('seccion-visible');
            }
          });
        }, {
          threshold: 0,
          rootMargin: '0px 0px -50px 0px'
        });

        observador.observe(this);
      }
    }

    if (!customElements.get('footer-personalizado')) {
      customElements.define('footer-personalizado', FooterPersonalizado);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["audio-player"] && !Shopify.designMode) return;
  try {
    
  (function () {
    let audioContextCompartido = null;

    function obtenerAudioContext() {
      if (!audioContextCompartido) {
        try {
          const ContextClass = window.AudioContext || window.webkitAudioContext;
          if (ContextClass) {
            audioContextCompartido = new ContextClass();
          }
        } catch (error) {
          console.warn('No se pudo crear AudioContext:', error);
        }
      }
      return audioContextCompartido;
    }

    class ReproductoresAudio extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.items = this.querySelectorAll('.item-reproductor-audio');
        this.miniReproductor = this.querySelector('[data-mini-reproductor]');
        this.audioActivo = null;
        this.itemActivo = null;

        if (this.miniReproductor) {
          this.miniBotonPlay = this.miniReproductor.querySelector('[data-mini-boton-play]');
          this.miniTitulo = this.miniReproductor.querySelector('[data-mini-titulo]');
          this.miniBarra = this.miniReproductor.querySelector('[data-mini-barra]');
          this.miniProgreso = this.miniReproductor.querySelector('[data-mini-progreso]');
          this.miniTiempoActual = this.miniReproductor.querySelector('[data-mini-tiempo-actual]');
          this.miniTiempoTotal = this.miniReproductor.querySelector('[data-mini-tiempo-total]');
          this.miniCerrar = this.miniReproductor.querySelector('[data-mini-cerrar]');

          this.inicializarMiniReproductor();
        }

        this.items.forEach((item) => this.inicializarItem(item));
      }

      generarSemillaNumerica(cadena) {
        let hash = 0;
        for (let i = 0; i < cadena.length; i++) {
          hash = ((hash << 5) - hash) + cadena.charCodeAt(i);
          hash |= 0;
        }
        return Math.abs(hash);
      }

      generadorPseudoaleatorio(semilla) {
        let estado = semilla || 1;
        return function () {
          estado = (estado * 9301 + 49297) % 233280;
          return estado / 233280;
        };
      }

      generarSvgOndaConDatos(datos, numeroBarras) {
        const anchoBarra = 2;
        const espacioBarra = 1;
        const anchoTotal = numeroBarras * (anchoBarra + espacioBarra);
        const altoTotal = 40;
        const alturaMaxima = 36;
        const alturaMinima = 2;

        let barras = '';
        for (let i = 0; i < numeroBarras; i++) {
          let factor = datos[i] || 0;
          factor = Math.min(Math.max(factor, 0), 1);
          const altura = alturaMinima + factor * (alturaMaxima - alturaMinima);
          const x = i * (anchoBarra + espacioBarra);
          const y = (altoTotal - altura) / 2;
          barras += '<rect x="' + x + '" y="' + y.toFixed(2) + '" width="' + anchoBarra + '" height="' + altura.toFixed(2) + '" rx="0.5"></rect>';
        }

        return '<svg viewBox="0 0 ' + anchoTotal + ' ' + altoTotal + '" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">' + barras + '</svg>';
      }

      generarDatosFallback(semilla, numeroBarras) {
        const random = this.generadorPseudoaleatorio(this.generarSemillaNumerica(semilla));
        const datos = [];
        for (let i = 0; i < numeroBarras; i++) {
          let factor = random();
          factor = Math.pow(factor, 0.7);
          datos.push(factor);
        }
        return datos;
      }

      async extraerDatosReales(urlAudio, numeroBarras) {
        const ctx = obtenerAudioContext();
        if (!ctx) {
          throw new Error('AudioContext no disponible');
        }

        const respuesta = await fetch(urlAudio);
        if (!respuesta.ok) {
          throw new Error('No se pudo descargar el audio');
        }

        const buffer = await respuesta.arrayBuffer();
        const audioBuffer = await ctx.decodeAudioData(buffer);

        const canalIzquierdo = audioBuffer.getChannelData(0);
        const muestrasPorBarra = Math.floor(canalIzquierdo.length / numeroBarras);
        const datos = [];

        let valorMaximoGlobal = 0;

        for (let i = 0; i < numeroBarras; i++) {
          const inicio = i * muestrasPorBarra;
          const fin = inicio + muestrasPorBarra;
          let sumaCuadrados = 0;

          for (let j = inicio; j < fin; j++) {
            sumaCuadrados += canalIzquierdo[j] * canalIzquierdo[j];
          }

          const rms = Math.sqrt(sumaCuadrados / muestrasPorBarra);
          datos.push(rms);
          if (rms > valorMaximoGlobal) {
            valorMaximoGlobal = rms;
          }
        }

        if (valorMaximoGlobal > 0) {
          for (let i = 0; i < datos.length; i++) {
            datos[i] = datos[i] / valorMaximoGlobal;
            datos[i] = Math.pow(datos[i], 0.7);
          }
        }

        return datos;
      }

      formatearTiempo(segundos) {
        if (isNaN(segundos) || segundos < 0) return '0:00';
        const mins = Math.floor(segundos / 60);
        const secs = Math.floor(segundos % 60);
        return mins + ':' + (secs < 10 ? '0' : '') + secs;
      }

      async inicializarItem(item) {
        const boton = item.querySelector('[data-boton-play]');
        const audio = item.querySelector('[data-audio]');
        const contenedorOnda = item.querySelector('[data-contenedor-onda]');
        const ondaFondo = item.querySelector('[data-onda-fondo]');
        const ondaProgreso = item.querySelector('[data-onda-progreso]');
        const cabezal = item.querySelector('[data-cabezal-onda]');
        const tituloEl = item.querySelector('[data-titulo-pista]');

        if (!boton || !contenedorOnda || !ondaFondo || !ondaProgreso) return;

        const semilla = contenedorOnda.getAttribute('data-semilla') || 'default';

        const calcularNumeroBarras = () => {
          const anchoContenedor = contenedorOnda.clientWidth || 300;
          return Math.max(40, Math.floor(anchoContenedor / 3));
        };

        const renderizarOndas = (datos) => {
          const numeroBarras = calcularNumeroBarras();
          const anchoContenedor = contenedorOnda.clientWidth || 300;
          const datosFinales = datos && datos.length >= numeroBarras ? datos : this.generarDatosFallback(semilla, numeroBarras);
          const svgOnda = this.generarSvgOndaConDatos(datosFinales, numeroBarras);

          ondaFondo.innerHTML = svgOnda;
          ondaProgreso.innerHTML = svgOnda;

          const svgEnProgreso = ondaProgreso.querySelector('svg');
          if (svgEnProgreso) {
            svgEnProgreso.style.setProperty('width', anchoContenedor + 'px', 'important');
            svgEnProgreso.setAttribute('preserveAspectRatio', 'none');
          }
        };

        renderizarOndas(null);
        ondaFondo.classList.add('onda-cargando');

        if (audio && audio.src) {
          this.extraerDatosReales(audio.src, calcularNumeroBarras())
            .then((datosReales) => {
              renderizarOndas(datosReales);
              ondaFondo.classList.remove('onda-cargando');
              item.dataset.datosOnda = JSON.stringify(datosReales);
            })
            .catch((error) => {
              console.warn('No se pudo analizar el audio, usando onda decorativa:', error);
              ondaFondo.classList.remove('onda-cargando');
            });
        } else {
          ondaFondo.classList.remove('onda-cargando');
        }

        if ('ResizeObserver' in window) {
          const resizeObserver = new ResizeObserver(() => {
            const datosGuardados = item.dataset.datosOnda ? JSON.parse(item.dataset.datosOnda) : null;
            renderizarOndas(datosGuardados);
          });
          resizeObserver.observe(contenedorOnda);
        }

        ondaProgreso.style.setProperty('width', '0%', 'important');
        if (cabezal) cabezal.style.setProperty('left', '0%', 'important');

        if (!audio) {
          boton.disabled = true;
          boton.style.opacity = '0.4';
          boton.style.cursor = 'not-allowed';
          return;
        }

        const titulo = tituloEl ? tituloEl.textContent.trim() : '';

        boton.addEventListener('click', () => {
          if (audio.paused) {
            this.pausarTodosExcepto(audio);
            audio.play();
          } else {
            audio.pause();
          }
        });

        audio.addEventListener('play', () => {
          item.classList.add('reproduciendo');
          item.classList.add('tiene-progreso');
          this.audioActivo = audio;
          this.itemActivo = item;
          if (this.miniReproductor) {
            this.miniTitulo.textContent = titulo || '—';
            this.mostrarMiniReproductor();
            this.miniReproductor.classList.add('mini-reproduciendo');
          }
        });

        audio.addEventListener('pause', () => {
          item.classList.remove('reproduciendo');
          if (this.miniReproductor && this.audioActivo === audio) {
            this.miniReproductor.classList.remove('mini-reproduciendo');
          }
        });

        audio.addEventListener('ended', () => {
          item.classList.remove('reproduciendo');
          item.classList.remove('tiene-progreso');
          ondaProgreso.style.setProperty('width', '0%', 'important');
          if (cabezal) cabezal.style.setProperty('left', '0%', 'important');
          if (this.miniReproductor && this.audioActivo === audio) {
            this.miniReproductor.classList.remove('mini-reproduciendo');
            this.miniProgreso.style.setProperty('width', '0%', 'important');
            this.miniTiempoActual.textContent = '0:00';
          }
        });

        audio.addEventListener('loadedmetadata', () => {
          if (this.miniReproductor && this.audioActivo === audio) {
            this.miniTiempoTotal.textContent = this.formatearTiempo(audio.duration);
          }
        });

        /* timeupdate solo se dispara unas 4 veces por segundo: de ahi que la
           onda y la barra inferior avanzaran a saltos. Mientras suena se
           repinta en cada fotograma con requestAnimationFrame, y timeupdate
           se conserva para cuando rAF no corre (pestana en segundo plano) y
           para los saltos al pinchar en la onda. */
        let rafProgreso = null;
        let ultimoSegundo = -1;

        const pintarProgreso = () => {
          if (!audio.duration || isNaN(audio.duration)) return;
          const progreso = (audio.currentTime / audio.duration) * 100;
          ondaProgreso.style.setProperty('width', progreso + '%', 'important');
          if (cabezal) cabezal.style.setProperty('left', progreso + '%', 'important');
          if (this.miniReproductor && this.audioActivo === audio) {
            this.miniProgreso.style.setProperty('width', progreso + '%', 'important');
            /* El texto solo cuando cambia el segundo: no tiene sentido tocar
               el DOM 60 veces por segundo para escribir el mismo numero. */
            const seg = Math.floor(audio.currentTime);
            if (seg !== ultimoSegundo) {
              ultimoSegundo = seg;
              this.miniTiempoActual.textContent = this.formatearTiempo(audio.currentTime);
              this.miniTiempoTotal.textContent = this.formatearTiempo(audio.duration);
            }
          }
        };

        const bucleProgreso = () => {
          pintarProgreso();
          rafProgreso = window.requestAnimationFrame(bucleProgreso);
        };

        const pararBucle = () => {
          if (rafProgreso) {
            window.cancelAnimationFrame(rafProgreso);
            rafProgreso = null;
          }
          pintarProgreso();
        };

        audio.addEventListener('playing', () => {
          pararBucle();
          bucleProgreso();
        });
        ['pause', 'ended', 'waiting'].forEach((evento) => {
          audio.addEventListener(evento, pararBucle);
        });
        audio.addEventListener('timeupdate', pintarProgreso);
        audio.addEventListener('seeking', pintarProgreso);

        contenedorOnda.addEventListener('click', (evento) => {
          if (!audio.duration || isNaN(audio.duration)) return;
          const rect = contenedorOnda.getBoundingClientRect();
          const posicionX = evento.clientX - rect.left;
          const proporcion = Math.max(0, Math.min(1, posicionX / rect.width));
          audio.currentTime = proporcion * audio.duration;
        });
      }

      inicializarMiniReproductor() {
        if (this.miniBotonPlay) {
          this.miniBotonPlay.addEventListener('click', () => {
            if (!this.audioActivo) return;
            if (this.audioActivo.paused) {
              this.audioActivo.play();
            } else {
              this.audioActivo.pause();
            }
          });
        }

        if (this.miniBarra) {
          this.miniBarra.addEventListener('click', (evento) => {
            if (!this.audioActivo || !this.audioActivo.duration) return;
            const rect = this.miniBarra.getBoundingClientRect();
            const posicionX = evento.clientX - rect.left;
            const proporcion = Math.max(0, Math.min(1, posicionX / rect.width));
            this.audioActivo.currentTime = proporcion * this.audioActivo.duration;
          });
        }

        if (this.miniCerrar) {
          this.miniCerrar.addEventListener('click', () => {
            if (this.audioActivo && !this.audioActivo.paused) {
              this.audioActivo.pause();
            }
            this.ocultarMiniReproductor();
          });
        }
      }

      mostrarMiniReproductor() {
        if (!this.miniReproductor) return;
        this.miniReproductor.classList.add('mini-visible');
        this.miniReproductor.setAttribute('aria-hidden', 'false');
      }

      ocultarMiniReproductor() {
        if (!this.miniReproductor) return;
        this.miniReproductor.classList.remove('mini-visible');
        this.miniReproductor.classList.remove('mini-reproduciendo');
        this.miniReproductor.setAttribute('aria-hidden', 'true');
      }

      pausarTodosExcepto(audioActivo) {
        const audios = document.querySelectorAll('reproductores-audio [data-audio]');
        audios.forEach((audio) => {
          if (audio !== audioActivo && !audio.paused) {
            audio.pause();
          }
        });
      }
    }

    if (!customElements.get('reproductores-audio')) {
      customElements.define('reproductores-audio', ReproductoresAudio);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cierre-about-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class CierreAboutFaq extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.permitirMultiples = this.getAttribute('data-permitir-multiples') === 'true';
        this.duracionFaq = parseInt(this.getAttribute('data-duracion-faq'), 10) || 400;
        this.elementosAnimados = this.querySelectorAll('[data-elemento-animado]');
        this.itemsPregunta = this.querySelectorAll('[data-item-pregunta]');

        this.iniciarObservadorEntrada();
        this.iniciarAcordeonAnimado();
      }

      iniciarObservadorEntrada() {
        if (this.prefiereReducirMovimiento()) {
          this.mostrarTodoSinAnimacion();
          return;
        }

        const opciones = {
          threshold: 0.1,
          rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entradas) => {
          entradas.forEach((entrada) => {
            if (entrada.isIntersecting) {
              this.animarElementos();
              observer.disconnect();
            }
          });
        }, opciones);

        observer.observe(this);
      }

      prefiereReducirMovimiento() {
        return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      mostrarTodoSinAnimacion() {
        this.elementosAnimados.forEach((el) => el.classList.add('elemento-visible'));
      }

      animarElementos() {
        this.elementosAnimados.forEach((elemento, indice) => {
          setTimeout(() => {
            elemento.classList.add('elemento-visible');
          }, indice * 100);
        });
      }

      iniciarAcordeonAnimado() {
        if (this.itemsPregunta.length === 0) return;

        this.itemsPregunta.forEach((item) => {
          const summary = item.querySelector('summary');
          const cuerpo = item.querySelector('[data-cuerpo-respuesta]');
          if (!summary || !cuerpo) return;

          summary.addEventListener('click', (evento) => {
            evento.preventDefault();
            this.alternarPregunta(item, cuerpo);
          });
        });
      }

      alternarPregunta(item, cuerpo) {
        const estaAbierto = item.hasAttribute('open');

        if (estaAbierto) {
          this.cerrarPregunta(item, cuerpo);
        } else {
          if (!this.permitirMultiples) {
            this.itemsPregunta.forEach((otroItem) => {
              if (otroItem !== item && otroItem.hasAttribute('open')) {
                const otroCuerpo = otroItem.querySelector('[data-cuerpo-respuesta]');
                if (otroCuerpo) {
                  this.cerrarPregunta(otroItem, otroCuerpo);
                }
              }
            });
          }
          this.abrirPregunta(item, cuerpo);
        }
      }

      abrirPregunta(item, cuerpo) {
        if (this.prefiereReducirMovimiento()) {
          item.setAttribute('open', '');
          return;
        }

        if (item._animacionActual) {
          item._animacionActual.cancel();
        }

        item.setAttribute('open', '');
        item.classList.add('animando-abrir');

        const alturaInicio = 0;
        const alturaFinal = cuerpo.offsetHeight;

        cuerpo.style.overflow = 'hidden';

        const animacion = cuerpo.animate(
          [
            { height: alturaInicio + 'px', opacity: 0 },
            { height: alturaFinal + 'px', opacity: 1 }
          ],
          {
            duration: this.duracionFaq,
            easing: 'ease-out'
          }
        );

        item._animacionActual = animacion;

        animacion.onfinish = () => {
          cuerpo.style.overflow = '';
          item.classList.remove('animando-abrir');
          item._animacionActual = null;
        };
      }

      cerrarPregunta(item, cuerpo) {
        if (this.prefiereReducirMovimiento()) {
          item.removeAttribute('open');
          return;
        }

        if (item._animacionActual) {
          item._animacionActual.cancel();
        }

        item.classList.add('animando-cerrar');

        const alturaInicio = cuerpo.offsetHeight;
        const alturaFinal = 0;

        cuerpo.style.overflow = 'hidden';

        const animacion = cuerpo.animate(
          [
            { height: alturaInicio + 'px', opacity: 1 },
            { height: alturaFinal + 'px', opacity: 0 }
          ],
          {
            duration: this.duracionFaq,
            easing: 'ease-in'
          }
        );

        item._animacionActual = animacion;

        animacion.onfinish = () => {
          item.removeAttribute('open');
          cuerpo.style.overflow = '';
          item.classList.remove('animando-cerrar');
          item._animacionActual = null;
        };
      }
    }

    if (!customElements.get('cierre-about-faq')) {
      customElements.define('cierre-about-faq', CierreAboutFaq);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dos-tarjetas-destacadas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class DosTarjetasAnimadas extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.animacionEjecutada = false;
        this.iniciarObservador();
      }

      iniciarObservador() {
        const activarSiVisible = () => {
          const rect = this.getBoundingClientRect();
          const visible = rect.top < window.innerHeight && rect.bottom > 0;
          if (visible) {
            this.dispararAnimacion();
          }
        };

        activarSiVisible();

        if (!('IntersectionObserver' in window)) {
          this.dispararAnimacion();
          return;
        }

        const observador = new IntersectionObserver((entradas) => {
          entradas.forEach((entrada) => {
            if (entrada.isIntersecting) {
              this.dispararAnimacion();
            }
          });
        }, {
          threshold: 0,
          rootMargin: '0px 0px -50px 0px'
        });

        observador.observe(this);
      }

      dispararAnimacion() {
        if (this.animacionEjecutada) return;
        this.animacionEjecutada = true;
        this.classList.add('seccion-visible');
      }
    }

    if (!customElements.get('dos-tarjetas-animadas')) {
      customElements.define('dos-tarjetas-animadas', DosTarjetasAnimadas);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-completo-categorias"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class FaqCompletoCategorias extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.permitirMultiples = this.getAttribute('data-permitir-multiples') === 'true';
        this.input = this.querySelector('[data-input-buscador]');
        this.tarjetas = this.querySelectorAll('[data-tarjeta-categoria]');
        this.seccionesCategoria = this.querySelectorAll('[data-seccion-categoria]');
        this.itemsPregunta = this.querySelectorAll('[data-item-pregunta]');
        this.mensajeSinResultados = this.querySelector('[data-mensaje-sin-resultados]');
        this.botones = this.querySelectorAll('[data-toggle-pregunta]');

        this.idCategoriaActiva = this.obtenerCategoriaActivaInicial();

        this.iniciarTarjetasCategorias();
        this.iniciarBuscador();
        this.iniciarAcordeon();
      }

      obtenerCategoriaActivaInicial() {
        const seccionActiva = this.querySelector('.seccion-categoria-activa');
        if (seccionActiva) {
          return seccionActiva.getAttribute('data-id-categoria');
        }
        return null;
      }

      iniciarTarjetasCategorias() {
        this.tarjetas.forEach((tarjeta) => {
          tarjeta.addEventListener('click', () => {
            const idCategoria = tarjeta.getAttribute('data-id-categoria');
            this.activarCategoria(idCategoria);
          });
        });
      }

      activarCategoria(idCategoria) {
        if (this.classList.contains('modo-busqueda')) {
          this.input.value = '';
          this.salirDeModoBusqueda();
        }

        this.tarjetas.forEach((tarjeta) => {
          if (tarjeta.getAttribute('data-id-categoria') === idCategoria) {
            tarjeta.classList.add('tarjeta-categoria-activa');
          } else {
            tarjeta.classList.remove('tarjeta-categoria-activa');
          }
        });

        this.seccionesCategoria.forEach((seccion) => {
          if (seccion.getAttribute('data-id-categoria') === idCategoria) {
            seccion.classList.add('seccion-categoria-activa');
          } else {
            seccion.classList.remove('seccion-categoria-activa');
          }
        });

        this.idCategoriaActiva = idCategoria;
        this.cerrarTodasLasPreguntas();
      }

      iniciarBuscador() {
        if (!this.input) return;

        let timeoutBusqueda;
        this.input.addEventListener('input', () => {
          clearTimeout(timeoutBusqueda);
          timeoutBusqueda = setTimeout(() => {
            this.ejecutarBusqueda();
          }, 150);
        });
      }

      ejecutarBusqueda() {
        const termino = this.input.value.trim().toLowerCase();

        if (termino === '') {
          this.salirDeModoBusqueda();
          return;
        }

        this.classList.add('modo-busqueda');

        let resultadosEncontrados = 0;

        this.itemsPregunta.forEach((item) => {
          const textoBusqueda = item.getAttribute('data-texto-busqueda') || '';
          const cuerpoRespuesta = item.querySelector('[data-cuerpo-respuesta]');
          const textoRespuesta = cuerpoRespuesta ? cuerpoRespuesta.textContent.toLowerCase() : '';
          const textoCompleto = textoBusqueda + ' ' + textoRespuesta;

          if (textoCompleto.includes(termino)) {
            item.classList.remove('oculta-por-busqueda');
            resultadosEncontrados++;
          } else {
            item.classList.add('oculta-por-busqueda');
          }
        });

        this.seccionesCategoria.forEach((seccion) => {
          const itemsVisiblesSeccion = seccion.querySelectorAll('[data-item-pregunta]:not(.oculta-por-busqueda)');
          if (itemsVisiblesSeccion.length === 0) {
            seccion.style.display = 'none';
          } else {
            seccion.style.display = '';
          }
        });

        if (this.mensajeSinResultados) {
          if (resultadosEncontrados === 0) {
            this.mensajeSinResultados.removeAttribute('hidden');
          } else {
            this.mensajeSinResultados.setAttribute('hidden', '');
          }
        }
      }

      salirDeModoBusqueda() {
        this.classList.remove('modo-busqueda');

        this.itemsPregunta.forEach((item) => {
          item.classList.remove('oculta-por-busqueda');
        });

        this.seccionesCategoria.forEach((seccion) => {
          seccion.style.display = '';
        });

        if (this.mensajeSinResultados) {
          this.mensajeSinResultados.setAttribute('hidden', '');
        }
      }

      iniciarAcordeon() {
        if (this.botones.length === 0) return;

        this.botones.forEach((boton) => {
          boton.addEventListener('click', () => {
            const item = boton.closest('[data-item-pregunta]');
            if (!item) return;

            const estaAbierta = item.classList.contains('pregunta-abierta');

            if (!this.permitirMultiples && !estaAbierta) {
              this.itemsPregunta.forEach((otroItem) => {
                if (otroItem !== item && otroItem.classList.contains('pregunta-abierta')) {
                  otroItem.classList.remove('pregunta-abierta');
                  const otroBoton = otroItem.querySelector('[data-toggle-pregunta]');
                  if (otroBoton) {
                    otroBoton.setAttribute('aria-expanded', 'false');
                  }
                }
              });
            }

            item.classList.toggle('pregunta-abierta');
            boton.setAttribute('aria-expanded', estaAbierta ? 'false' : 'true');
          });
        });
      }

      cerrarTodasLasPreguntas() {
        this.itemsPregunta.forEach((item) => {
          item.classList.remove('pregunta-abierta');
          const boton = item.querySelector('[data-toggle-pregunta]');
          if (boton) {
            boton.setAttribute('aria-expanded', 'false');
          }
        });
      }
    }

    if (!customElements.get('faq-completo-categorias')) {
      customElements.define('faq-completo-categorias', FaqCompletoCategorias);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filas-alternadas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRellenoTitulos(scope) {
      var raiz = scope || document;
      var titulos = raiz.querySelectorAll('[data-titulo-relleno]');
      if (!titulos.length) return;

      var registros = [];

      function trocearEnLineas(titulo) {
        // Guardar el texto original una sola vez.
        if (!titulo.dataset.textoOriginal) {
          titulo.dataset.textoOriginal = titulo.textContent;
        }
        var texto = titulo.dataset.textoOriginal;
        var palabras = texto.split(/\s+/).filter(Boolean);

        // Envolver cada palabra en un span para medir su posición.
        titulo.innerHTML = '';
        var spans = [];
        palabras.forEach(function (palabra, i) {
          var span = document.createElement('span');
          span.textContent = palabra;
          span.style.display = 'inline-block';
          titulo.appendChild(span);
          spans.push(span);
          if (i < palabras.length - 1) {
            titulo.appendChild(document.createTextNode(' '));
          }
        });

        // Agrupar palabras por línea según su offsetTop.
        var lineas = [];
        var topActual = null;
        var grupoActual = [];
        spans.forEach(function (span) {
          var top = span.offsetTop;
          if (topActual === null || Math.abs(top - topActual) > 4) {
            if (grupoActual.length) lineas.push(grupoActual);
            grupoActual = [span];
            topActual = top;
          } else {
            grupoActual.push(span);
          }
        });
        if (grupoActual.length) lineas.push(grupoActual);

        // Reconstruir: cada línea como un div con su texto, para aplicar el degradado por línea.
        titulo.innerHTML = '';
        var elementosLinea = [];
        lineas.forEach(function (grupo) {
          var divLinea = document.createElement('span');
          divLinea.className = 'linea-relleno-titulo';
          divLinea.textContent = grupo.map(function (s) { return s.textContent; }).join(' ');
          // Copia del texto en un data-attribute: lo usa el ::after de CSS
          // para pintar la capa de glow recortada al mismo progreso.
          divLinea.dataset.texto = divLinea.textContent;
          titulo.appendChild(divLinea);
          elementosLinea.push(divLinea);
        });

        titulo.classList.add('lineas-listas');
        return elementosLinea;
      }

      titulos.forEach(function (titulo) {
        var lineas = trocearEnLineas(titulo);
        registros.push({ titulo: titulo, lineas: lineas });
      });

      var ticking = false;

      function actualizar() {
        var alturaVentana = window.innerHeight;
        registros.forEach(function (reg) {
          var rect = reg.titulo.getBoundingClientRect();
          var inicio = alturaVentana * 0.85;
          var fin = alturaVentana * 0.35;
          var progreso = (inicio - rect.top) / (inicio - fin);
          if (progreso < 0) progreso = 0;
          if (progreso > 1) progreso = 1;

          // Repartir el progreso global entre las líneas en secuencia.
          var numLineas = reg.lineas.length;
          var progresoTotal = progreso * numLineas; // 0..numLineas
          reg.lineas.forEach(function (linea, i) {
            var progresoLinea = progresoTotal - i; // cuánto le toca a esta línea
            if (progresoLinea < 0) progresoLinea = 0;
            if (progresoLinea > 1) progresoLinea = 1;
            linea.style.setProperty('--linea-progreso', (progresoLinea * 100) + '%');
          });
        });
      }

      function alScroll() {
        if (!ticking) {
          requestAnimationFrame(function () {
            actualizar();
            ticking = false;
          });
          ticking = true;
        }
      }

      function reTrocear() {
        registros.forEach(function (reg) {
          reg.lineas = trocearEnLineas(reg.titulo);
        });
        actualizar();
      }

      window.addEventListener('scroll', alScroll, { passive: true });
      // Al cambiar el tamaño, las líneas cambian: hay que volver a trocear.
      var resizeTimeout = null;
      window.addEventListener('resize', function () {
        if (resizeTimeout) clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(reTrocear, 200);
      });
      actualizar();
    }

    function initFilasAlternadas(scope) {
      var raiz = scope || document;
      var filas = raiz.querySelectorAll('[data-fila-alternada]');
      var enEditor = window.Shopify && window.Shopify.designMode;

      filas.forEach(function (fila) {
        if (fila.dataset.filaListo === 'si') return;
        fila.dataset.filaListo = 'si';

        if (enEditor) return;

        fila.classList.add('fila-animar');

        function revelar() {
          fila.classList.add('fila-visible');
        }

        if (!('IntersectionObserver' in window)) {
          revelar();
          return;
        }

        var observador = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (entrada) {
            if (entrada.isIntersecting) {
              revelar();
              observador.disconnect();
            }
          });
        }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });

        observador.observe(fila);

        setTimeout(function () {
          if (!fila.classList.contains('fila-visible')) revelar();
        }, 2500);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initFilasAlternadas(document);
        initRellenoTitulos(document);
      });
    } else {
      initFilasAlternadas(document);
      initRellenoTitulos(document);
    }

    document.addEventListener('shopify:section:load', function (e) {
      initFilasAlternadas(e.target || document);
      initRellenoTitulos(e.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-personalizado"]) return;
  try {
    
  (function () {
    class FooterPersonalizado extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.iniciarObservadorVisibilidad();
      }

      iniciarObservadorVisibilidad() {
        const activarSiVisible = () => {
          const rect = this.getBoundingClientRect();
          const visible = rect.top < window.innerHeight && rect.bottom > 0;
          if (visible) {
            this.classList.add('seccion-visible');
          }
        };

        activarSiVisible();

        if (!('IntersectionObserver' in window)) {
          this.classList.add('seccion-visible');
          return;
        }

        const observador = new IntersectionObserver((entradas) => {
          entradas.forEach((entrada) => {
            if (entrada.isIntersecting) {
              this.classList.add('seccion-visible');
            }
          });
        }, {
          threshold: 0,
          rootMargin: '0px 0px -50px 0px'
        });

        observador.observe(this);
      }
    }

    if (!customElements.get('footer-personalizado')) {
      customElements.define('footer-personalizado', FooterPersonalizado);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["freebies-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class SeccionFreebies extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sectionId = this.getAttribute('data-section-id');
        this.tarjetas = Array.from(this.querySelectorAll('[data-tarjeta-freebie]'));
        this.barraFlotante = this.querySelector('[data-barra-flotante]');
        this.contadorBarra = this.querySelector('[data-contador-barra]');
        this.contadorModal = this.querySelector('[data-contador-modal]');
        this.botonAbrirModal = this.querySelector('[data-abrir-modal]');
        this.modal = this.querySelector('[data-modal-freebies]');
        this.botonesCerrarModal = this.querySelectorAll('[data-cerrar-modal]');
        this.formulario = this.querySelector('[data-formulario-freebies]');
        this.botonSubmit = this.querySelector('[data-submit-formulario]');
        this.mensajeError = this.querySelector('[data-mensaje-error]');

        this.seleccionados = new Set();

        this.bindEventos();
      }

      bindEventos() {
        // Toggle de cada tarjeta
        this.tarjetas.forEach((tarjeta) => {
          const boton = tarjeta.querySelector('[data-boton-unlock]');
          if (boton) {
            boton.addEventListener('click', () => this.toggleSeleccion(tarjeta, boton));
          }
        });

        // Abrir modal
        if (this.botonAbrirModal) {
          this.botonAbrirModal.addEventListener('click', () => this.abrirModal());
        }

        // Cerrar modal
        this.botonesCerrarModal.forEach((boton) => {
          boton.addEventListener('click', () => this.cerrarModal());
        });

        // Submit
        if (this.formulario) {
          this.formulario.addEventListener('submit', (e) => this.enviarFormulario(e));
        }

        // ESC para cerrar modal
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.modal && !this.modal.hidden) {
            this.cerrarModal();
          }
        });
      }

      toggleSeleccion(tarjeta, boton) {
        const variantId = tarjeta.getAttribute('data-variant-id');
        if (!variantId) return;

        if (this.seleccionados.has(variantId)) {
          this.seleccionados.delete(variantId);
          boton.setAttribute('aria-pressed', 'false');
        } else {
          this.seleccionados.add(variantId);
          boton.setAttribute('aria-pressed', 'true');
        }

        this.actualizarBarra();
      }

      actualizarBarra() {
        const cantidad = this.seleccionados.size;
        if (this.contadorBarra) this.contadorBarra.textContent = cantidad;
        if (this.contadorModal) this.contadorModal.textContent = cantidad;

        if (!this.barraFlotante) return;

        if (cantidad > 0) {
          this.barraFlotante.hidden = false;
          requestAnimationFrame(() => this.barraFlotante.classList.add('visible'));
        } else {
          this.barraFlotante.classList.remove('visible');
          setTimeout(() => {
            if (this.seleccionados.size === 0) this.barraFlotante.hidden = true;
          }, 300);
        }
      }

      abrirModal() {
        if (!this.modal || this.seleccionados.size === 0) return;
        this.modal.hidden = false;
        document.body.style.overflow = 'hidden';
        requestAnimationFrame(() => this.modal.classList.add('visible'));

        // Focus al primer input
        setTimeout(() => {
          const primerInput = this.modal.querySelector('input');
          if (primerInput) primerInput.focus();
        }, 200);
      }

      cerrarModal() {
        if (!this.modal) return;
        this.modal.classList.remove('visible');
        document.body.style.overflow = '';
        setTimeout(() => {
          this.modal.hidden = true;
          if (this.mensajeError) {
            this.mensajeError.hidden = true;
            this.mensajeError.textContent = '';
          }
        }, 300);
      }

      mostrarError(mensaje) {
        if (!this.mensajeError) return;
        this.mensajeError.textContent = mensaje;
        this.mensajeError.hidden = false;
      }

      setCargando(cargando) {
        if (!this.botonSubmit) return;
        const txtDefault = this.botonSubmit.querySelector('.texto-submit-default');
        const txtCargando = this.botonSubmit.querySelector('.texto-submit-cargando');
        this.botonSubmit.disabled = cargando;
        if (txtDefault) txtDefault.hidden = cargando;
        if (txtCargando) txtCargando.hidden = !cargando;
      }

      async enviarFormulario(e) {
        e.preventDefault();
        if (!this.formulario) return;
        if (this.seleccionados.size === 0) {
          this.mostrarError('Please select at least one freebie.');
          return;
        }

        // Limpiar errores previos
        if (this.mensajeError) this.mensajeError.hidden = true;
        this.formulario.querySelectorAll('.input-freebie').forEach((i) => i.classList.remove('input-error'));

        const formData = new FormData(this.formulario);
        const nombre = (formData.get('nombre') || '').toString().trim();
        const apellidos = (formData.get('apellidos') || '').toString().trim();
        const email = (formData.get('email') || '').toString().trim();

        // Validación
        let hayError = false;
        if (!nombre) {
          this.formulario.querySelector('[name="nombre"]').classList.add('input-error');
          hayError = true;
        }
        if (!apellidos) {
          this.formulario.querySelector('[name="apellidos"]').classList.add('input-error');
          hayError = true;
        }
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          this.formulario.querySelector('[name="email"]').classList.add('input-error');
          hayError = true;
        }
        if (hayError) {
          this.mostrarError('Please fill in all required fields with valid data.');
          return;
        }

        this.setCargando(true);

        try {
          // 1. Limpiar carrito (para no mezclar con productos de pago)
          await fetch('/cart/clear.js', { method: 'POST' });

          // 2. Añadir todos los freebies al carrito
          const items = Array.from(this.seleccionados).map((id) => ({
            id: parseInt(id, 10),
            quantity: 1
          }));

          const respuestaAdd = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });

          if (!respuestaAdd.ok) {
            const err = await respuestaAdd.json().catch(() => ({}));
            throw new Error(err.description || 'Could not add freebies to cart.');
          }

          // 3. Actualizar atributos del carrito con datos del cliente
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              attributes: {
                'Freebie request': 'yes',
                'First name': nombre,
                'Last name': apellidos,
                'Email': email
              },
              note: 'FREEBIES REQUEST — ' + nombre + ' ' + apellidos + ' (' + email + ')'
            })
          });

          // 4. Redirigir al checkout con email pre-rellenado
          const params = new URLSearchParams({
            'checkout[email]': email,
            'checkout[shipping_address][first_name]': nombre,
            'checkout[shipping_address][last_name]': apellidos
          });
          window.location.href = '/checkout?' + params.toString();
        } catch (error) {
          this.setCargando(false);
          this.mostrarError(error.message || 'Something went wrong. Please try again.');
        }
      }
    }

    if (!customElements.get('seccion-freebies')) {
      customElements.define('seccion-freebies', SeccionFreebies);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["galeria-3d-inmersiva"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class Galeria3DInmersiva extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.escenario = this.querySelector('[data-escenario]');
        this.contenedorFijo = this.querySelector('[data-contenedor-fijo]');
        this.items = this.querySelectorAll('[data-item-3d]');
        this.textosFase = this.querySelectorAll('[data-texto-fase]');
        this.iconoGlow = this.querySelector('[data-icono-glow]');
        this.contenedorFase3 = this.querySelector('[data-contenedor-fase-3]');
        this.textoMitadIzquierda = this.querySelector('[data-texto-mitad="izquierda"]');
        this.textoMitadDerecha = this.querySelector('[data-texto-mitad="derecha"]');

        this.debug = this.getAttribute('data-debug') === 'true';
        this.panelDebug = this.querySelector('[data-panel-debug]');
        if (this.debug && this.panelDebug) {
          this.debugProgreso = this.querySelector('[data-debug-progreso]');
          this.debugFase = this.querySelector('[data-debug-fase]');
          this.debugDesplazamiento = this.querySelector('[data-debug-desplazamiento]');
          this.debugEscala = this.querySelector('[data-debug-escala]');
          this.debugIzq = this.querySelector('[data-debug-izq]');
          this.debugDer = this.querySelector('[data-debug-der]');

          if (this.debugIzq) this.debugIzq.textContent = this.textoMitadIzquierda ? 'SI' : 'NO';
          if (this.debugDer) this.debugDer.textContent = this.textoMitadDerecha ? 'SI' : 'NO';
        }

        this.dispersionZ = parseInt(this.getAttribute('data-dispersion-z'), 10) || 2500;
        this.dispersionXY = parseInt(this.getAttribute('data-dispersion-xy'), 10) || 200;
        this.radioZonaSeguraMovil = parseInt(this.getAttribute('data-radio-zona-segura-movil'), 10) || 400;
        this.radioZonaSeguraDesktop = parseInt(this.getAttribute('data-radio-zona-segura-desktop'), 10) || 700;
        this.zMaximoAcercamiento = parseInt(this.getAttribute('data-z-maximo-acercamiento'), 10) || -200;
        this.escalaFinalIconoMovil = parseFloat(this.getAttribute('data-escala-final-icono-movil')) || 10;
        this.escalaFinalIconoDesktop = parseFloat(this.getAttribute('data-escala-final-icono-desktop')) || 15;

        this.progreso = 0;
        this.frameId = null;
        this.esMobil = window.innerWidth < 990;

        if (this.prefiereReducirMovimiento()) {
          return;
        }

        this.distribuirItems();
        this.iniciarObservadorScroll();
        this.escucharResize();
        this.actualizarAnimacion();
      }

      prefiereReducirMovimiento() {
        return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      hashSemilla(numero) {
        let x = Math.sin(numero * 9973.137) * 10000;
        return x - Math.floor(x);
      }

      distribuirItems() {
        const total = this.items.length;
        if (total === 0) return;

        const radioMinimo = this.esMobil ? this.radioZonaSeguraMovil : this.radioZonaSeguraDesktop;

        this.items.forEach((item, indice) => {
          const semillaX = this.hashSemilla(indice + 1);
          const semillaY = this.hashSemilla(indice + 100);
          const semillaZ = this.hashSemilla(indice + 200);

          const angulo = (indice / total) * Math.PI * 2;
          const radio = radioMinimo + this.dispersionXY * (0.3 + semillaX * 0.7);

          const x = Math.cos(angulo) * radio + (semillaX - 0.5) * 80;
          const y = Math.sin(angulo) * radio * 0.7 + (semillaY - 0.5) * 80;
          const zInicial = -this.dispersionZ * (semillaZ * 0.8 + 0.2);

          item.dataset.x = x.toFixed(0);
          item.dataset.y = y.toFixed(0);
          item.dataset.zInicial = zInicial.toFixed(0);

          item.style.transform = 'translate(' + x.toFixed(0) + 'px, ' + y.toFixed(0) + 'px) translateZ(' + zInicial.toFixed(0) + 'px)';
        });
      }

      iniciarObservadorScroll() {
        const onScroll = () => {
          if (this.frameId) return;
          this.frameId = requestAnimationFrame(() => {
            this.actualizarAnimacion();
            this.frameId = null;
          });
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        this.actualizarAnimacion();
      }

      escucharResize() {
        let timeoutResize;
        window.addEventListener('resize', () => {
          clearTimeout(timeoutResize);
          timeoutResize = setTimeout(() => {
            this.esMobil = window.innerWidth < 990;
            this.distribuirItems();
            this.actualizarAnimacion();
          }, 150);
        });
      }

      actualizarAnimacion() {
        const rect = this.getBoundingClientRect();
        const alturaSeccion = this.offsetHeight;
        const alturaViewport = window.innerHeight;
        const alturaScrolleable = alturaSeccion - alturaViewport;

        const top = rect.top;
        const scrollEnSeccion = -top;

        if (top > 0) {
          this.contenedorFijo.classList.remove('modo-fijo');
          this.contenedorFijo.classList.remove('modo-final');
        } else if (scrollEnSeccion >= alturaScrolleable) {
          this.contenedorFijo.classList.remove('modo-fijo');
          this.contenedorFijo.classList.add('modo-final');
        } else {
          this.contenedorFijo.classList.add('modo-fijo');
          this.contenedorFijo.classList.remove('modo-final');
        }

        let progreso = scrollEnSeccion / alturaScrolleable;
        progreso = Math.max(0, Math.min(1, progreso));
        this.progreso = progreso;

        this.actualizarItems(progreso);
        this.actualizarTextosFases12(progreso);
        this.actualizarIconoGlow(progreso);
        this.actualizarFase3(progreso);
        this.actualizarPanelDebug(progreso);
      }

      actualizarItems(progreso) {
        const progresoGaleria = Math.min(1, progreso / 0.7);
        const avanceCamara = progresoGaleria * (this.dispersionZ + 800);

        this.items.forEach((item) => {
          const x = parseFloat(item.dataset.x);
          const y = parseFloat(item.dataset.y);
          const zInicial = parseFloat(item.dataset.zInicial);
          let zActual = zInicial + avanceCamara;

          if (zActual > this.zMaximoAcercamiento) {
            zActual = this.zMaximoAcercamiento;
          }

          let opacidad = 1;
          if (zActual >= this.zMaximoAcercamiento) {
            const exceso = (zInicial + avanceCamara) - this.zMaximoAcercamiento;
            opacidad = Math.max(0, 1 - exceso / 400);
          }

          if (progresoGaleria >= 1) {
            opacidad = 0;
          }

          item.style.transform = 'translate(' + x + 'px, ' + y + 'px) translateZ(' + zActual.toFixed(0) + 'px)';
          item.style.opacity = opacidad.toFixed(2);
        });
      }

      actualizarTextosFases12(progreso) {
        let faseActiva = 0;

        if (progreso < 0.25) {
          faseActiva = 1;
        } else if (progreso >= 0.25 && progreso < 0.5) {
          faseActiva = 2;
        }

        this.textosFase.forEach((texto) => {
          const fase = parseInt(texto.getAttribute('data-texto-fase'), 10);
          if (fase === faseActiva && faseActiva !== 0) {
            texto.classList.add('texto-activo');
          } else {
            texto.classList.remove('texto-activo');
          }
        });
      }

      actualizarIconoGlow(progreso) {
        if (!this.iconoGlow) return;

        const inicio = 0.7;
        const fin = 1.0;
        const factorContenedor = 0.65;
        const escalaMaxima = this.esMobil ? this.escalaFinalIconoMovil : this.escalaFinalIconoDesktop;
        const escalaMaximaContenedor = escalaMaxima * factorContenedor;
        const escalaInicial = 0.1 / escalaMaximaContenedor;

        if (progreso < inicio) {
          this.iconoGlow.style.opacity = '0';
          this.iconoGlow.style.transform = 'scale(' + escalaInicial.toFixed(4) + ')';
          this._escalaActualIcono = 0;
          return;
        }

        const progresoIcono = Math.min(1, (progreso - inicio) / (fin - inicio));
        const escalaVisual = 0.1 + Math.pow(progresoIcono, 1.8) * escalaMaxima;
        const escalaCSS = escalaVisual / escalaMaximaContenedor;

        this.iconoGlow.style.transform = 'scale(' + escalaCSS.toFixed(4) + ')';
        this.iconoGlow.style.opacity = '1';
        this._escalaActualIcono = escalaVisual;
      }

      actualizarFase3(progreso) {
        if (!this.contenedorFase3) return;

        const inicioAparicion = 0.5;
        const finAparicion = 0.62;
        const inicioSeparacion = 0.7;
        const finSeparacion = 0.88;
        const inicioDesvanecer = 0.85;
        const finDesvanecer = 0.95;

        const distanciaMaxima = this.esMobil ? 250 : 500;

        if (progreso < inicioAparicion) {
          this.contenedorFase3.style.opacity = '0';
          if (this.textoMitadIzquierda) {
            this.textoMitadIzquierda.style.transform = 'translateX(0px)';
          }
          if (this.textoMitadDerecha) {
            this.textoMitadDerecha.style.transform = 'translateX(0px)';
          }
          this._desplazamientoActual = 0;
          return;
        }

        let opacidadFase3 = 0;

        if (progreso >= inicioAparicion && progreso < finAparicion) {
          opacidadFase3 = (progreso - inicioAparicion) / (finAparicion - inicioAparicion);
        } else if (progreso >= finAparicion && progreso < inicioDesvanecer) {
          opacidadFase3 = 1;
        } else if (progreso >= inicioDesvanecer && progreso < finDesvanecer) {
          opacidadFase3 = 1 - (progreso - inicioDesvanecer) / (finDesvanecer - inicioDesvanecer);
        } else {
          opacidadFase3 = 0;
        }

        opacidadFase3 = Math.max(0, Math.min(1, opacidadFase3));
        this.contenedorFase3.style.opacity = opacidadFase3.toFixed(2);

        let desplazamiento = 0;
        if (progreso >= inicioSeparacion) {
          const progresoSeparacion = Math.max(0, Math.min(1, (progreso - inicioSeparacion) / (finSeparacion - inicioSeparacion)));
          desplazamiento = Math.pow(progresoSeparacion, 1.2) * distanciaMaxima;
        }

        this._desplazamientoActual = desplazamiento;

        if (this.textoMitadIzquierda) {
          this.textoMitadIzquierda.style.transform = 'translateX(' + (-desplazamiento).toFixed(0) + 'px)';
        }

        if (this.textoMitadDerecha) {
          this.textoMitadDerecha.style.transform = 'translateX(' + desplazamiento.toFixed(0) + 'px)';
        }
      }

      actualizarPanelDebug(progreso) {
        if (!this.debug || !this.panelDebug) return;

        let fase = 0;
        if (progreso < 0.25) fase = 1;
        else if (progreso < 0.5) fase = 2;
        else fase = 3;

        if (this.debugProgreso) this.debugProgreso.textContent = (progreso * 100).toFixed(1) + '%';
        if (this.debugFase) this.debugFase.textContent = fase;
        if (this.debugDesplazamiento) this.debugDesplazamiento.textContent = (this._desplazamientoActual || 0).toFixed(0);
        if (this.debugEscala) this.debugEscala.textContent = (this._escalaActualIcono || 0).toFixed(2);
      }
    }

    if (!customElements.get('galeria-3d-inmersiva')) {
      customElements.define('galeria-3d-inmersiva', Galeria3DInmersiva);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ghost-producing-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGhostScroll(scope) {
      var raiz = scope || document;
      var botones = raiz.querySelectorAll('[data-scroll-formulario]');
      botones.forEach(function (boton) {
        if (boton.dataset.scrollListo === 'si') return;
        boton.dataset.scrollListo = 'si';
        boton.addEventListener('click', function (e) {
          var destino = boton.getAttribute('href');
          if (!destino || destino.charAt(0) !== '#') return;
          var objetivo = document.querySelector(destino);
          if (!objetivo) return;

          e.preventDefault();

          var header = document.querySelector('header-personalizado.seccion-header-personalizado--fixed');
          var offsetHeader = header ? header.offsetHeight : 0;
          var margenExtra = 20;
          var posicion = objetivo.getBoundingClientRect().top + window.pageYOffset - offsetHeader - margenExtra;
          var prefiereReducir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          window.scrollTo({
            top: posicion,
            behavior: prefiereReducir ? 'auto' : 'smooth'
          });
        });
      });
    }

    function activarAnimaciones(scope) {
      var raiz = scope || document;
      var heroes = raiz.querySelectorAll('[data-hero-ghost]');

      // Si estamos dentro del editor de Shopify, no animar: mostrar todo directamente.
      var enEditor = window.Shopify && window.Shopify.designMode;

      heroes.forEach(function (hero) {
        if (enEditor) {
          // En el editor, garantizar contenido visible sin animación.
          hero.classList.remove('animaciones-listas');
          return;
        }

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            hero.classList.add('animaciones-listas');
          });
        });

        // Seguro de vida: pase lo que pase, a los 2s el contenido debe estar visible.
        setTimeout(function () {
          var elementos = hero.querySelectorAll('.animar-entrada-ghost');
          elementos.forEach(function (el) {
            var estilo = window.getComputedStyle(el);
            if (parseFloat(estilo.opacity) < 0.95) {
              el.style.setProperty('opacity', '1', 'important');
              el.style.setProperty('transform', 'none', 'important');
              el.style.setProperty('animation', 'none', 'important');
            }
          });
        }, 2000);
      });
    }

    function formatearTiempo(segundos) {
      if (isNaN(segundos) || segundos < 0) return '0:00';
      var min = Math.floor(segundos / 60);
      var seg = Math.floor(segundos % 60);
      return min + ':' + (seg < 10 ? '0' : '') + seg;
    }

    function initTracksPlayers(scope) {
      var raiz = scope || document;
      var tarjetas = raiz.querySelectorAll('[data-track-ghost]');
      var todosLosAudios = [];

      tarjetas.forEach(function (tarjeta) {
        var audio = tarjeta.querySelector('[data-audio-track]');
        if (audio) todosLosAudios.push(audio);
      });

      tarjetas.forEach(function (tarjeta) {
        if (tarjeta.dataset.playerListo === 'si') return;
        tarjeta.dataset.playerListo = 'si';

        var audio = tarjeta.querySelector('[data-audio-track]');
        var botonPlay = tarjeta.querySelector('[data-play-track]');
        var barra = tarjeta.querySelector('[data-barra-progreso]');
        var relleno = tarjeta.querySelector('[data-relleno-progreso]');
        var tiempoActual = tarjeta.querySelector('[data-tiempo-actual]');
        var tiempoTotal = tarjeta.querySelector('[data-tiempo-total]');

        if (!audio || !botonPlay) return;

        botonPlay.addEventListener('click', function () {
          if (audio.paused) {
            // Pausar cualquier otro audio que esté sonando.
            todosLosAudios.forEach(function (otro) {
              if (otro !== audio) {
                otro.pause();
              }
            });
            audio.play();
          } else {
            audio.pause();
          }
        });

        audio.addEventListener('play', function () {
          tarjeta.classList.add('reproduciendo');
        });
        audio.addEventListener('pause', function () {
          tarjeta.classList.remove('reproduciendo');
        });
        audio.addEventListener('ended', function () {
          tarjeta.classList.remove('reproduciendo');
          if (relleno) relleno.style.setProperty('transform', 'scaleX(0)', 'important');
          if (tiempoActual) tiempoActual.textContent = '0:00';
        });

        audio.addEventListener('loadedmetadata', function () {
          if (tiempoTotal) tiempoTotal.textContent = formatearTiempo(audio.duration);
        });

        /* El evento timeupdate solo se dispara unas 4 veces por segundo: de ahi
           que la barra avanzara a saltos. Mientras suena, se repinta en cada
           fotograma con requestAnimationFrame; timeupdate se conserva para los
           casos en que rAF no corre (pestana en segundo plano) y para los
           saltos al mover la barra. */
        var rafProgreso = null;
        var ultimoSegundo = -1;

        function pintarProgreso() {
          if (!audio.duration || isNaN(audio.duration)) return;
          var ratio = audio.currentTime / audio.duration;
          if (relleno) relleno.style.setProperty('transform', 'scaleX(' + ratio + ')', 'important');
          /* El texto solo se reescribe cuando cambia el segundo: no tiene
             sentido tocar el DOM 60 veces por segundo para el mismo numero. */
          var seg = Math.floor(audio.currentTime);
          if (tiempoActual && seg !== ultimoSegundo) {
            ultimoSegundo = seg;
            tiempoActual.textContent = formatearTiempo(audio.currentTime);
          }
        }

        function bucleProgreso() {
          pintarProgreso();
          rafProgreso = window.requestAnimationFrame(bucleProgreso);
        }

        function pararBucle() {
          if (rafProgreso) {
            window.cancelAnimationFrame(rafProgreso);
            rafProgreso = null;
          }
          pintarProgreso();
        }

        audio.addEventListener('playing', function () {
          pararBucle();
          bucleProgreso();
        });
        ['pause', 'ended', 'waiting'].forEach(function (evento) {
          audio.addEventListener(evento, pararBucle);
        });
        audio.addEventListener('timeupdate', pintarProgreso);
        audio.addEventListener('seeking', pintarProgreso);

        if (barra) {
          barra.addEventListener('click', function (e) {
            if (!audio.duration) return;
            var rect = barra.getBoundingClientRect();
            var ratio = (e.clientX - rect.left) / rect.width;
            audio.currentTime = ratio * audio.duration;
          });
        }
      });
    }

    function initCarrusel(scope) {
      var raiz = scope || document;
      var carruseles = raiz.querySelectorAll('[data-carrusel-tracks]');

      carruseles.forEach(function (carrusel) {
        if (carrusel.dataset.carruselListo === 'si') return;
        carrusel.dataset.carruselListo = 'si';

        var pista = carrusel.querySelector('[data-pista-carrusel]');
        var btnPrev = carrusel.querySelector('[data-carrusel-prev]');
        var btnNext = carrusel.querySelector('[data-carrusel-next]');
        if (!pista) return;

        function calcularPaso() {
          var tarjeta = pista.querySelector('[data-track-ghost]');
          if (!tarjeta) return 280;
          var estilo = window.getComputedStyle(pista);
          var gap = parseFloat(estilo.columnGap || estilo.gap || '16');
          return tarjeta.offsetWidth + gap;
        }

        function actualizarBotones() {
          var maxScroll = pista.scrollWidth - pista.clientWidth - 2;
          var hayAntes = pista.scrollLeft > 4;
          var hayDespues = pista.scrollLeft < maxScroll;

          /* Las clases alimentan la mascara de difuminado del CSS. */
          pista.classList.toggle('hay-antes', hayAntes);
          pista.classList.toggle('hay-despues', hayDespues);

          if (!btnPrev || !btnNext) return;
          btnPrev.disabled = !hayAntes;
          btnNext.disabled = !hayDespues;
        }

        if (btnPrev) {
          btnPrev.addEventListener('click', function () {
            pista.scrollBy({ left: -calcularPaso(), behavior: 'smooth' });
          });
        }
        if (btnNext) {
          btnNext.addEventListener('click', function () {
            pista.scrollBy({ left: calcularPaso(), behavior: 'smooth' });
          });
        }

        pista.addEventListener('scroll', actualizarBotones, { passive: true });
        window.addEventListener('resize', actualizarBotones);
        actualizarBotones();
      });
    }

    function initDosTarjetas(scope) {
      var raiz = scope || document;
      var secciones = raiz.querySelectorAll('.dos-tarjetas-ghost');
      var enEditor = window.Shopify && window.Shopify.designMode;

      secciones.forEach(function (seccion) {
        if (seccion.dataset.dtListo === 'si') return;
        seccion.dataset.dtListo = 'si';

        // En el editor de Shopify, mostrar sin animación.
        if (enEditor) {
          return;
        }

        // Activar el modo animado (los elementos parten ocultos).
        seccion.classList.add('dt-animar');

        function revelar() {
          seccion.classList.add('dt-visible');
        }

        if (!('IntersectionObserver' in window)) {
          revelar();
          return;
        }

        var observador = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (entrada) {
            if (entrada.isIntersecting) {
              revelar();
              observador.disconnect();
            }
          });
        }, { threshold: 0, rootMargin: '0px 0px -50px 0px' });

        observador.observe(seccion);

        // Seguro de vida: a los 2.5s, visible pase lo que pase.
        setTimeout(function () {
          if (!seccion.classList.contains('dt-visible')) {
            revelar();
          }
        }, 2500);
      });
    }

    function initGhost(scope) {
      initGhostScroll(scope);
      activarAnimaciones(scope);
      initTracksPlayers(scope);
      initCarrusel(scope);
      initDosTarjetas(scope);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initGhost(document); });
    } else {
      initGhost(document);
    }

    // Eventos del editor de temas de Shopify: re-inicializar al recargar la sección.
    document.addEventListener('shopify:section:load', function (e) {
      initGhost(e.target || document);
    });
    document.addEventListener('shopify:section:select', function (e) {
      activarAnimaciones(e.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grid-productos-pspmusic"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class GridProductosPSPMusic extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sectionId = this.getAttribute('data-section-id');
        this.sidebar = this.querySelector('[data-sidebar-filtros]');
        this.overlay = this.querySelector('[data-overlay-sidebar]');
        this.botonAbrirSidebar = this.querySelector('[data-abrir-sidebar]');
        this.botonCerrarSidebar = this.querySelector('[data-cerrar-sidebar]');
        this.botonesLimpiar = this.querySelectorAll('[data-limpiar-filtros]');
        this.selectSort = this.querySelector('[data-sort-productos]');
        this.botonesVista = this.querySelectorAll('[data-vista]');
        this.gridProductos = this.querySelector('[data-grid-productos]');
        this.tarjetas = Array.from(this.querySelectorAll('[data-tarjeta-producto]'));
        this.checkboxesFiltro = this.querySelectorAll('input[data-filtro]');
        this.togglesGrupo = this.querySelectorAll('[data-toggle-grupo]');
        this.contadorItems = this.querySelector('[data-contador-items]');
        this.estadoVacioFiltros = this.querySelector('[data-estado-vacio-filtros]');

        this.storageKeyVista = 'gpp_vista_' + this.sectionId;

        this.iniciarSidebarMovil();
        this.iniciarToggleGrupos();
        this.iniciarFiltros();
        this.iniciarSort();
        this.iniciarToggleVista();
        this.iniciarAnimacionEntrada();
        this.actualizarContadoresFiltros();
        this.leerFiltrosURL();
        /* Al cargar no se anima: la cuadricula ya tiene su propia animacion
           de aparicion y las dos se solaparian. */
        this.aplicarFiltros(true);
      }

      iniciarSidebarMovil() {
        if (this.botonAbrirSidebar) {
          this.botonAbrirSidebar.addEventListener('click', () => this.abrirSidebar());
        }
        if (this.botonCerrarSidebar) {
          this.botonCerrarSidebar.addEventListener('click', () => this.cerrarSidebar());
        }
        if (this.overlay) {
          this.overlay.addEventListener('click', () => this.cerrarSidebar());
        }
      }

      abrirSidebar() {
        if (!this.sidebar || !this.overlay) return;
        this.sidebar.classList.add('abierto');
        this.overlay.hidden = false;
        requestAnimationFrame(() => this.overlay.classList.add('visible'));
        document.body.style.overflow = 'hidden';
      }

      cerrarSidebar() {
        if (!this.sidebar || !this.overlay) return;
        this.sidebar.classList.remove('abierto');
        this.overlay.classList.remove('visible');
        setTimeout(() => { this.overlay.hidden = true; }, 300);
        document.body.style.overflow = '';
      }

      iniciarToggleGrupos() {
        this.togglesGrupo.forEach((boton) => {
          boton.addEventListener('click', (e) => {
            e.preventDefault();
            const expanded = boton.getAttribute('aria-expanded') === 'true';
            boton.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          });
        });
      }

      iniciarFiltros() {
        this.checkboxesFiltro.forEach((cb) => {
          cb.addEventListener('change', () => {
            this.aplicarFiltros();
            this.escribirFiltrosURL();
          });
        });

        this.botonesLimpiar.forEach((boton) => {
          boton.addEventListener('click', () => this.limpiarFiltros());
        });
      }

      obtenerFiltrosActivos() {
        const filtros = { tipo: [], genero: [], formato: [] };
        this.checkboxesFiltro.forEach((cb) => {
          if (cb.checked) {
            const tipo = cb.getAttribute('data-filtro');
            const valor = cb.value;
            if (filtros[tipo]) filtros[tipo].push(valor);
          }
        });
        return filtros;
      }

      /* Envoltorio de animacion.
         Se funde la cuadricula entera, se aplica el filtro mientras esta
         invisible y se devuelve con una entrada escalonada. Animar tarjeta a
         tarjeta seria peor: al ocultarse unas, las que quedan saltan de sitio
         de golpe, y suavizar eso exige medir posiciones antes y despues. Con
         la cuadricula fundida, ese reflow ocurre sin que nadie lo vea. */
      aplicarFiltros(sinAnimacion) {
        const grid = this.querySelector('[data-grid-productos]');

        const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (sinAnimacion || reducido || !grid) {
          this.ejecutarFiltros();
          return;
        }

        if (this.animandoFiltro) clearTimeout(this.animandoFiltro);

        grid.classList.add('grid-filtrando');

        this.animandoFiltro = setTimeout(() => {
          this.ejecutarFiltros();

          /* Escalonado de entrada: cada tarjeta visible recibe su retardo por
             variable CSS, para no crear una regla por indice. */
          const visibles = this.tarjetas.filter(
            (t) => !t.classList.contains('oculta-por-filtro')
          );
          visibles.forEach((t, i) => {
            t.style.setProperty('--gpp-retardo-entrada', Math.min(i * 35, 280) + 'ms');
          });

          requestAnimationFrame(() => {
            grid.classList.remove('grid-filtrando');
          });
        }, 180);
      }

      ejecutarFiltros() {
        const filtros = this.obtenerFiltrosActivos();
        const hayFiltros = filtros.tipo.length > 0 || filtros.genero.length > 0 || filtros.formato.length > 0;

        let visibles = 0;

        this.tarjetas.forEach((tarjeta) => {
          const tipo = tarjeta.getAttribute('data-tipo') || '';
          const formato = tarjeta.getAttribute('data-formato') || '';
          const generosStr = tarjeta.getAttribute('data-generos') || '';
          const generos = generosStr.split(',').filter(Boolean);

          let coincide = true;

          if (filtros.tipo.length > 0 && !filtros.tipo.includes(tipo)) {
            coincide = false;
          }
          if (filtros.formato.length > 0 && !filtros.formato.includes(formato)) {
            coincide = false;
          }
          if (filtros.genero.length > 0) {
            const tieneAlguno = filtros.genero.some((g) => generos.includes(g));
            if (!tieneAlguno) coincide = false;
          }

          if (coincide) {
            tarjeta.classList.remove('oculta-por-filtro');
            visibles++;
          } else {
            tarjeta.classList.add('oculta-por-filtro');
          }
        });

        if (this.contadorItems) {
          this.contadorItems.textContent = visibles;
        }

        if (this.estadoVacioFiltros) {
          this.estadoVacioFiltros.hidden = visibles > 0;
        }

        this.botonesLimpiar.forEach((boton) => {
          boton.hidden = !hayFiltros;
        });
      }

      limpiarFiltros() {
        this.checkboxesFiltro.forEach((cb) => { cb.checked = false; });
        this.aplicarFiltros();
        this.escribirFiltrosURL();
      }

      escribirFiltrosURL() {
        const filtros = this.obtenerFiltrosActivos();
        const params = new URLSearchParams(window.location.search);

        ['tipo', 'genero', 'formato'].forEach((key) => {
          params.delete(key);
          if (filtros[key].length > 0) {
            params.set(key, filtros[key].join(','));
          }
        });

        const nuevaURL = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
        window.history.replaceState({}, '', nuevaURL);
      }

      leerFiltrosURL() {
        const params = new URLSearchParams(window.location.search);
        ['tipo', 'genero', 'formato'].forEach((key) => {
          const valor = params.get(key);
          if (!valor) return;
          const valores = valor.split(',');
          this.checkboxesFiltro.forEach((cb) => {
            if (cb.getAttribute('data-filtro') === key && valores.includes(cb.value)) {
              cb.checked = true;
            }
          });
        });
      }

      actualizarContadoresFiltros() {
        const contadores = this.querySelectorAll('[data-contador-filtro]');
        contadores.forEach((span) => {
          const ref = span.getAttribute('data-contador-filtro');
          const partes = ref.split(':');
          const tipo = partes[0];
          const valor = partes[1];

          let cuenta = 0;
          this.tarjetas.forEach((tarjeta) => {
            if (tipo === 'genero') {
              const generos = (tarjeta.getAttribute('data-generos') || '').split(',').filter(Boolean);
              if (generos.includes(valor)) cuenta++;
            } else {
              if (tarjeta.getAttribute('data-' + tipo) === valor) cuenta++;
            }
          });

          span.textContent = cuenta;
        });
      }

      iniciarSort() {
        if (!this.selectSort) return;
        this.selectSort.addEventListener('change', () => this.aplicarSort());
      }

      aplicarSort() {
        const valor = this.selectSort.value;
        const tarjetasOrdenadas = [...this.tarjetas];

        tarjetasOrdenadas.sort((a, b) => {
          if (valor === 'title-ascending') {
            return a.getAttribute('data-titulo').localeCompare(b.getAttribute('data-titulo'));
          }
          if (valor === 'title-descending') {
            return b.getAttribute('data-titulo').localeCompare(a.getAttribute('data-titulo'));
          }
          if (valor === 'price-ascending') {
            return parseInt(a.getAttribute('data-precio'), 10) - parseInt(b.getAttribute('data-precio'), 10);
          }
          if (valor === 'price-descending') {
            return parseInt(b.getAttribute('data-precio'), 10) - parseInt(a.getAttribute('data-precio'), 10);
          }
          if (valor === 'created-descending') {
            return parseInt(b.getAttribute('data-creado'), 10) - parseInt(a.getAttribute('data-creado'), 10);
          }
          return 0;
        });

        tarjetasOrdenadas.forEach((tarjeta) => this.gridProductos.appendChild(tarjeta));
      }

      iniciarToggleVista() {
        const vistaGuardada = localStorage.getItem(this.storageKeyVista) || 'grid';
        this.cambiarVista(vistaGuardada, false);

        this.botonesVista.forEach((boton) => {
          boton.addEventListener('click', () => {
            const vista = boton.getAttribute('data-vista');
            this.cambiarVista(vista, true);
          });
        });
      }

      cambiarVista(vista, guardar) {
        this.botonesVista.forEach((boton) => {
          if (boton.getAttribute('data-vista') === vista) {
            boton.classList.add('activo');
          } else {
            boton.classList.remove('activo');
          }
        });

        if (this.gridProductos) {
          this.gridProductos.classList.remove('modo-grid', 'modo-lista');
          this.gridProductos.classList.add('modo-' + vista);
        }

        if (guardar) {
          localStorage.setItem(this.storageKeyVista, vista);
        }
      }

      iniciarAnimacionEntrada() {
        if (!('IntersectionObserver' in window)) {
          this.tarjetas.forEach((t) => t.classList.add('visible'));
          return;
        }

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry, indice) => {
            if (entry.isIntersecting) {
              const delay = indice * 60;
              setTimeout(() => {
                entry.target.classList.add('visible');
              }, delay);
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

        this.tarjetas.forEach((tarjeta) => observer.observe(tarjeta));
      }
    }

    if (!customElements.get('grid-productos-pspmusic')) {
      customElements.define('grid-productos-pspmusic', GridProductosPSPMusic);
    }

    // --- Add to cart por AJAX (tarjetas de la colección) --------------------
    document.addEventListener('click', function (e) {
      var boton = e.target.closest('.boton-carrito-grid');
      if (!boton) return;
      e.preventDefault();
      e.stopPropagation();

      var id = boton.getAttribute('data-variante-id');
      if (!id || boton.classList.contains('is-loading') || boton.classList.contains('is-done')) return;

      boton.classList.add('is-loading');

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart');
          return res.json();
        })
        .then(function () {
          boton.classList.remove('is-loading');
          boton.classList.add('is-done');

          fetch(window.Shopify.routes.root + 'cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.querySelectorAll('[data-cart-count]').forEach(function (c) {
                c.textContent = cart.item_count;
                c.hidden = cart.item_count === 0;
              });
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
            });

          setTimeout(function () { boton.classList.remove('is-done'); }, 1800);
        })
        .catch(function () {
          boton.classList.remove('is-loading');
          boton.classList.add('is-error');
          setTimeout(function () { boton.classList.remove('is-error'); }, 1800);
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-pro"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class HeaderPersonalizado extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.botonHamburguesa = this.querySelector('.boton-hamburguesa-header');
        this.botonBuscar = this.querySelector('.boton-buscar-header');
        this.drawerBuscador = this.querySelector('[data-drawer-buscador]');
        this.drawerMovil = this.querySelector('[data-drawer-movil]');
        this.panelDrawer = this.querySelector('.panel-drawer-movil');
        this.vistaPrincipal = this.querySelector('.vista-drawer--principal');
        this.vistasSubmenu = this.querySelectorAll('.vista-drawer--submenu');
        this.botonesAbrirSubmenu = this.querySelectorAll('[data-abrir-submenu]');
        this.botonesVolverSubmenu = this.querySelectorAll('[data-volver-submenu]');
        this.botonesCerrarDrawer = this.querySelectorAll('[data-cerrar-drawer]');
        this.botonCerrarBuscador = this.querySelector('[data-cerrar-buscador]');
        this.inputBuscador = this.querySelector('.input-buscador-header');
        this.contadorCarrito = this.querySelector('[data-cart-count]');
        this.cascadasSubsub = this.querySelectorAll('.cascada-subsubmenu');
        this.selectorPais = this.querySelector('.selector-pais-header');
        this.bindEvents();
        this.actualizarContadorCarrito();
        this.escucharCambiosCarrito();
        this.escucharResize();
        this.inicializarEspaciador();
        this.ajustarCascadasSubsub();
        this.inicializarSelectorPais();
        this.inicializarBuscadorPaisMovil();
      }
      inicializarEspaciador() {
        if (!this.classList.contains('seccion-header-personalizado--fixed')) return;
        const raiz = document.documentElement;
        const actualizarPosicionYEspaciador = () => {
          /* El header va SIEMPRE pegado al borde superior del viewport.
             Antes se le restaba la altura de [data-barra-superior], lo que lo
             empujaba hacia abajo y dejaba ver el video del hero por encima. */
          this.style.setProperty('top', '0px', 'important');
          const alturaHeader = this.offsetHeight;
          /* El header publica su propia altura real: el solapamiento del hero
             deja de depender del fallback de 92px de noize.css. */
          raiz.style.setProperty('--nz-header-altura', alturaHeader + 'px');
          raiz.style.setProperty('--nz-header-altura-movil', alturaHeader + 'px');
          if (document.body) {
            document.body.style.setProperty('--nz-header-altura', alturaHeader + 'px');
            document.body.style.setProperty('--nz-header-altura-movil', alturaHeader + 'px');
          }
          document.querySelectorAll('[data-espaciador-header]').forEach((espaciador) => {
            espaciador.style.setProperty('height', alturaHeader + 'px', 'important');
          });
        };
        actualizarPosicionYEspaciador();
        requestAnimationFrame(() => actualizarPosicionYEspaciador());
        setTimeout(actualizarPosicionYEspaciador, 100);
        setTimeout(actualizarPosicionYEspaciador, 500);
        if ('ResizeObserver' in window) {
          const observador = new ResizeObserver(() => actualizarPosicionYEspaciador());
          observador.observe(this);
        }
        window.addEventListener('resize', actualizarPosicionYEspaciador);
        window.addEventListener('load', actualizarPosicionYEspaciador);
        const imagenes = this.querySelectorAll('img');
        imagenes.forEach((img) => {
          if (!img.complete) {
            img.addEventListener('load', actualizarPosicionYEspaciador, { once: true });
          }
        });
      }
      ajustarCascadasSubsub() {
        const evaluar = () => {
          this.cascadasSubsub.forEach((cascada) => {
            cascada.classList.remove('cascada-abre-izquierda');
            const padre = cascada.parentElement;
            if (!padre) return;
            const rectPadre = padre.getBoundingClientRect();
            const anchoCascada = cascada.offsetWidth || 220;
            const espacioDerecha = window.innerWidth - rectPadre.right;
            if (espacioDerecha < anchoCascada + 20) {
              cascada.classList.add('cascada-abre-izquierda');
            }
          });
        };
        setTimeout(evaluar, 50);
        window.addEventListener('resize', evaluar);
      }
      inicializarSelectorPais() {
        if (!this.selectorPais) return;
        const boton = this.selectorPais.querySelector('.boton-pais-header');
        if (!boton) return;
        boton.addEventListener('click', (event) => {
          event.stopPropagation();
          const abierto = this.selectorPais.classList.contains('pais-abierto');
          if (abierto) {
            this.cerrarSelectorPais();
          } else {
            this.selectorPais.classList.add('pais-abierto');
            boton.setAttribute('aria-expanded', 'true');
          }
        });
        document.addEventListener('click', (event) => {
          if (!this.selectorPais.contains(event.target)) {
            this.cerrarSelectorPais();
          }
        });
      }
      cerrarSelectorPais() {
        if (!this.selectorPais) return;
        this.selectorPais.classList.remove('pais-abierto');
        const boton = this.selectorPais.querySelector('.boton-pais-header');
        if (boton) boton.setAttribute('aria-expanded', 'false');
      }
      inicializarBuscadorPaisMovil() {
        const input = this.querySelector('[data-buscador-pais]');
        if (!input) return;
        const items = this.querySelectorAll('.item-pais-buscable');
        const mensaje = this.querySelector('[data-sin-resultados-pais]');
        if (!items.length) return;

        const filtrar = () => {
          const consulta = (input.value || '').trim().toLowerCase();
          let visibles = 0;
          items.forEach((item) => {
            const nombre = item.getAttribute('data-nombre-pais') || '';
            if (!consulta || nombre.indexOf(consulta) !== -1) {
              item.classList.remove('pais-oculto');
              visibles++;
            } else {
              item.classList.add('pais-oculto');
            }
          });
          if (mensaje) {
            if (visibles === 0) {
              mensaje.removeAttribute('hidden');
            } else {
              mensaje.setAttribute('hidden', '');
            }
          }
        };

        input.addEventListener('input', filtrar);

        // Al volver al menú principal o cerrar el drawer, limpiar el filtro
        const limpiar = () => {
          input.value = '';
          filtrar();
        };
        const vista = input.closest('.vista-drawer');
        if (vista) {
          const botonVolver = vista.querySelector('[data-volver-submenu]');
          if (botonVolver) botonVolver.addEventListener('click', limpiar);
        }
        this.botonesCerrarDrawer.forEach((boton) => {
          boton.addEventListener('click', limpiar);
        });
      }
      bindEvents() {
        if (this.botonHamburguesa) {
          this.botonHamburguesa.addEventListener('click', () => this.toggleDrawerMovil());
        }
        if (this.botonBuscar) {
          this.botonBuscar.addEventListener('click', () => this.toggleDrawerBuscador());
        }
        this.botonesCerrarDrawer.forEach((boton) => {
          boton.addEventListener('click', () => this.cerrarDrawerMovil());
        });
        this.botonesAbrirSubmenu.forEach((boton) => {
          boton.addEventListener('click', () => {
            const id = boton.getAttribute('data-abrir-submenu');
            this.abrirSubmenu(id);
          });
        });
        this.botonesVolverSubmenu.forEach((boton) => {
          boton.addEventListener('click', () => {
            const target = boton.getAttribute('data-target-vista');
            if (target === 'principal' || !target) {
              this.volverAlPrincipal();
            } else {
              this.volverAVista(target);
            }
          });
        });
        if (this.botonCerrarBuscador) {
          this.botonCerrarBuscador.addEventListener('click', () => this.cerrarDrawerBuscador());
        }
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.cerrarDrawerMovil();
            this.cerrarDrawerBuscador();
            this.cerrarSelectorPais();
          }
        });
      }
      toggleDrawerMovil() {
        if (!this.drawerMovil) return;
        const estaAbierto = this.drawerMovil.classList.contains('activo');
        estaAbierto ? this.cerrarDrawerMovil() : this.abrirDrawerMovil();
      }
      abrirDrawerMovil() {
        if (!this.drawerMovil) return;
        this.drawerMovil.classList.add('activo');
        this.drawerMovil.setAttribute('aria-hidden', 'false');
        if (this.botonHamburguesa) this.botonHamburguesa.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      }
      cerrarDrawerMovil() {
        if (!this.drawerMovil) return;
        this.drawerMovil.classList.remove('activo');
        this.drawerMovil.setAttribute('aria-hidden', 'true');
        if (this.botonHamburguesa) this.botonHamburguesa.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        setTimeout(() => this.volverAlPrincipal(), 350);
      }
      abrirSubmenu(id) {
        const vista = this.querySelector('[data-vista="' + id + '"]');
        if (!vista) return;
        const esSubsubmenu = vista.classList.contains('vista-drawer--subsubmenu');
        if (esSubsubmenu) {
          this.vistasSubmenu.forEach((v) => {
            if (v.classList.contains('vista-activa') && v !== vista) {
              v.classList.add('vista-oculta');
            }
          });
          vista.classList.add('vista-activa');
        } else {
          this.vistasSubmenu.forEach((v) => {
            v.classList.remove('vista-activa');
            v.classList.remove('vista-oculta');
          });
          vista.classList.add('vista-activa');
          if (this.vistaPrincipal) this.vistaPrincipal.classList.add('vista-oculta');
        }
      }
      volverAVista(idTarget) {
        this.vistasSubmenu.forEach((v) => {
          if (v.classList.contains('vista-drawer--subsubmenu') && v.classList.contains('vista-activa')) {
            v.classList.remove('vista-activa');
          }
        });
        const vistaTarget = this.querySelector('[data-vista="' + idTarget + '"]');
        if (vistaTarget) {
          vistaTarget.classList.remove('vista-oculta');
          vistaTarget.classList.add('vista-activa');
        }
      }
      volverAlPrincipal() {
        this.vistasSubmenu.forEach((v) => {
          v.classList.remove('vista-activa');
          v.classList.remove('vista-oculta');
        });
        if (this.vistaPrincipal) this.vistaPrincipal.classList.remove('vista-oculta');
      }
      toggleDrawerBuscador() {
        if (!this.drawerBuscador) return;
        const estaAbierto = this.drawerBuscador.classList.contains('activo');
        estaAbierto ? this.cerrarDrawerBuscador() : this.abrirDrawerBuscador();
      }
      abrirDrawerBuscador() {
        if (!this.drawerBuscador) return;
        this.drawerBuscador.classList.add('activo');
        this.drawerBuscador.setAttribute('aria-hidden', 'false');
        setTimeout(() => {
          if (this.inputBuscador) this.inputBuscador.focus();
        }, 150);
      }
      cerrarDrawerBuscador() {
        if (!this.drawerBuscador) return;
        this.drawerBuscador.classList.remove('activo');
        this.drawerBuscador.setAttribute('aria-hidden', 'true');
      }
      async actualizarContadorCarrito() {
        if (!this.contadorCarrito) return;
        try {
          const respuesta = await fetch('/cart.js');
          const datos = await respuesta.json();
          this.renderContador(datos.item_count);
        } catch (error) {
          return;
        }
      }
      renderContador(cantidad) {
        if (!this.contadorCarrito) return;
        this.contadorCarrito.textContent = cantidad;
        if (cantidad > 0) {
          this.contadorCarrito.removeAttribute('hidden');
        } else {
          this.contadorCarrito.setAttribute('hidden', '');
        }
      }
      escucharCambiosCarrito() {
        document.addEventListener('cart:updated', () => this.actualizarContadorCarrito());
        document.addEventListener('cart:refresh', () => this.actualizarContadorCarrito());
      }
      escucharResize() {
        window.addEventListener('resize', () => {
          if (window.innerWidth >= 990) {
            this.cerrarDrawerMovil();
          }
        });
      }
    }
    if (!customElements.get('header-personalizado')) {
      customElements.define('header-personalizado', HeaderPersonalizado);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class ImageGridAnimado extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.iniciarObservadorVisibilidad();
      }

      iniciarObservadorVisibilidad() {
        const activarSiVisible = () => {
          const rect = this.getBoundingClientRect();
          const visible = rect.top < window.innerHeight && rect.bottom > 0;
          if (visible) {
            this.classList.add('seccion-visible');
          }
        };

        activarSiVisible();

        if (!('IntersectionObserver' in window)) {
          this.classList.add('seccion-visible');
          return;
        }

        const observador = new IntersectionObserver((entradas) => {
          entradas.forEach((entrada) => {
            if (entrada.isIntersecting) {
              this.classList.add('seccion-visible');
            }
          });
        }, {
          threshold: 0,
          rootMargin: '0px 0px -50px 0px'
        });

        observador.observe(this);
      }
    }

    if (!customElements.get('image-grid-animado')) {
      customElements.define('image-grid-animado', ImageGridAnimado);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mixing-mastering-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMixScroll(scope) {
      var raiz = scope || document;
      var botones = raiz.querySelectorAll('[data-scroll-planes]');
      botones.forEach(function (boton) {
        if (boton.dataset.scrollListo === 'si') return;
        boton.dataset.scrollListo = 'si';
        boton.addEventListener('click', function (e) {
          var destino = boton.getAttribute('href');
          if (!destino || destino.charAt(0) !== '#') return;
          var objetivo = document.querySelector(destino);
          if (!objetivo) return;
          e.preventDefault();
          var header = document.querySelector('header-personalizado.seccion-header-personalizado--fixed');
          var offsetHeader = header ? header.offsetHeight : 0;
          var posicion = objetivo.getBoundingClientRect().top + window.pageYOffset - offsetHeader - 20;
          var prefiereReducir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top: posicion, behavior: prefiereReducir ? 'auto' : 'smooth' });
        });
      });
    }

    function activarAnimacionesMix(scope) {
      var raiz = scope || document;
      var heroes = raiz.querySelectorAll('[data-hero-mix]');
      var enEditor = window.Shopify && window.Shopify.designMode;
      heroes.forEach(function (hero) {
        if (enEditor) {
          hero.classList.remove('animaciones-listas');
          return;
        }
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            hero.classList.add('animaciones-listas');
          });
        });
        setTimeout(function () {
          var elementos = hero.querySelectorAll('.animar-entrada-mix');
          elementos.forEach(function (el) {
            var estilo = window.getComputedStyle(el);
            if (parseFloat(estilo.opacity) < 0.95) {
              el.style.setProperty('opacity', '1', 'important');
              el.style.setProperty('transform', 'none', 'important');
              el.style.setProperty('animation', 'none', 'important');
            }
          });
        }, 2000);
      });
    }

    function initDosTarjetasMix(scope) {
      var raiz = scope || document;
      var secciones = raiz.querySelectorAll('.dos-tarjetas-mix');
      var enEditor = window.Shopify && window.Shopify.designMode;
      secciones.forEach(function (seccion) {
        if (seccion.dataset.dtListo === 'si') return;
        seccion.dataset.dtListo = 'si';
        if (enEditor) return;
        seccion.classList.add('dt-animar');
        function revelar() { seccion.classList.add('dt-visible'); }
        if (!('IntersectionObserver' in window)) { revelar(); return; }
        var observador = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (entrada) {
            if (entrada.isIntersecting) { revelar(); observador.disconnect(); }
          });
        }, { threshold: 0, rootMargin: '0px 0px -50px 0px' });
        observador.observe(seccion);
        setTimeout(function () {
          if (!seccion.classList.contains('dt-visible')) revelar();
        }, 2500);
      });
    }

    function initPlanesCarrito(scope) {
      var raiz = scope || document;
      var botones = raiz.querySelectorAll('[data-anadir-plan]');
      var toast = document.querySelector('[data-toast-mix]');
      var toastTimeout = null;

      function mostrarToast() {
        if (!toast) return;
        toast.hidden = false;
        requestAnimationFrame(function () {
          toast.classList.add('visible');
        });
        if (toastTimeout) clearTimeout(toastTimeout);
        toastTimeout = setTimeout(function () {
          toast.classList.remove('visible');
          setTimeout(function () { toast.hidden = true; }, 300);
        }, 4000);
      }

      function actualizarContadorCarrito() {
        // Avisar al header para que refresque el contador.
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }

      botones.forEach(function (boton) {
        if (boton.dataset.planListo === 'si') return;
        boton.dataset.planListo = 'si';

        var variantId = boton.getAttribute('data-variant-id');
        var txtDefault = boton.querySelector('.texto-boton-plan-default');
        var txtCargando = boton.querySelector('.texto-boton-plan-cargando');
        var txtOk = boton.querySelector('.texto-boton-plan-ok');

        boton.addEventListener('click', function () {
          if (!variantId || boton.disabled) return;

          boton.disabled = true;
          if (txtDefault) txtDefault.hidden = true;
          if (txtCargando) txtCargando.hidden = false;
          if (txtOk) txtOk.hidden = true;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: parseInt(variantId, 10), quantity: 1 }]
            })
          })
            .then(function (respuesta) {
              if (!respuesta.ok) throw new Error('add failed');
              return respuesta.json();
            })
            .then(function () {
              if (txtCargando) txtCargando.hidden = true;
              if (txtOk) txtOk.hidden = false;
              actualizarContadorCarrito();
              mostrarToast();
              setTimeout(function () {
                boton.disabled = false;
                if (txtOk) txtOk.hidden = true;
                if (txtDefault) txtDefault.hidden = false;
              }, 2500);
            })
            .catch(function () {
              boton.disabled = false;
              if (txtCargando) txtCargando.hidden = true;
              if (txtDefault) txtDefault.hidden = false;
            });
        });
      });
    }

    function initTutorial(scope) {
      var raiz = scope || document;
      var items = raiz.querySelectorAll('[data-item-tutorial]');
      items.forEach(function (item) {
        if (item.dataset.tutorialListo === 'si') return;
        item.dataset.tutorialListo = 'si';

        var cabecera = item.querySelector('[data-toggle-tutorial]');
        if (!cabecera) return;

        cabecera.addEventListener('click', function () {
          var abierto = item.classList.contains('abierto');
          if (abierto) {
            item.classList.remove('abierto');
            cabecera.setAttribute('aria-expanded', 'false');
          } else {
            item.classList.add('abierto');
            cabecera.setAttribute('aria-expanded', 'true');
          }
        });
      });
    }

    function initMix(scope) {
      initMixScroll(scope);
      activarAnimacionesMix(scope);
      initDosTarjetasMix(scope);
      initPlanesCarrito(scope);
      initTutorial(scope);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initMix(document); });
    } else {
      initMix(document);
    }

    document.addEventListener('shopify:section:load', function (e) {
      initMix(e.target || document);
    });
    document.addEventListener('shopify:section:select', function (e) {
      activarAnimacionesMix(e.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opiniones-artistas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class TestimoniosArtistas extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.pista = this.querySelector('[data-pista]');
        this.slides = this.querySelectorAll('[data-slide]');
        this.botonAnterior = this.querySelector('[data-boton-anterior]');
        this.botonSiguiente = this.querySelector('[data-boton-siguiente]');
        this.dots = this.querySelectorAll('[data-ir-a]');
        this.slider = this.querySelector('[data-slider]');

        this.indiceActual = 0;
        this.totalSlides = this.slides.length;
        this.autoplayActivo = this.getAttribute('data-autoplay') === 'true';
        this.intervalo = parseInt(this.getAttribute('data-intervalo'), 10) || 6000;
        this.temporizadorAutoplay = null;

        if (this.totalSlides === 0) return;

        this.bindEvents();
        this.iniciarObservadorVisibilidad();

        if (this.totalSlides > 1 && this.autoplayActivo) {
          this.iniciarAutoplay();
        }
      }

      bindEvents() {
        if (this.botonAnterior) {
          this.botonAnterior.addEventListener('click', () => {
            this.irASlide(this.indiceActual - 1);
            this.reiniciarAutoplay();
          });
        }

        if (this.botonSiguiente) {
          this.botonSiguiente.addEventListener('click', () => {
            this.irASlide(this.indiceActual + 1);
            this.reiniciarAutoplay();
          });
        }

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const indice = parseInt(dot.getAttribute('data-ir-a'), 10);
            this.irASlide(indice);
            this.reiniciarAutoplay();
          });
        });

        this.slider.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            this.irASlide(this.indiceActual - 1);
            this.reiniciarAutoplay();
          } else if (event.key === 'ArrowRight') {
            this.irASlide(this.indiceActual + 1);
            this.reiniciarAutoplay();
          }
        });

        this.slider.setAttribute('tabindex', '0');

        this.iniciarSwipe();

        this.slider.addEventListener('mouseenter', () => this.pausarAutoplay());
        this.slider.addEventListener('mouseleave', () => {
          if (this.autoplayActivo && this.totalSlides > 1) this.iniciarAutoplay();
        });
      }

      iniciarSwipe() {
        let inicioX = 0;
        let finX = 0;
        const umbral = 50;

        this.slider.addEventListener('touchstart', (e) => {
          inicioX = e.touches[0].clientX;
        }, { passive: true });

        this.slider.addEventListener('touchend', (e) => {
          finX = e.changedTouches[0].clientX;
          const diff = inicioX - finX;
          if (Math.abs(diff) > umbral) {
            if (diff > 0) {
              this.irASlide(this.indiceActual + 1);
            } else {
              this.irASlide(this.indiceActual - 1);
            }
            this.reiniciarAutoplay();
          }
        }, { passive: true });
      }

      irASlide(indice) {
        if (this.totalSlides === 0) return;
        let nuevoIndice = indice;
        if (nuevoIndice < 0) nuevoIndice = this.totalSlides - 1;
        if (nuevoIndice >= this.totalSlides) nuevoIndice = 0;

        this.indiceActual = nuevoIndice;
        const desplazamiento = -100 * this.indiceActual;
        this.pista.style.transform = 'translateX(' + desplazamiento + '%)';

        this.slides.forEach((slide, i) => {
          slide.setAttribute('aria-hidden', i === this.indiceActual ? 'false' : 'true');
        });

        this.dots.forEach((dot, i) => {
          if (i === this.indiceActual) {
            dot.classList.add('dot-activo');
          } else {
            dot.classList.remove('dot-activo');
          }
        });
      }

      iniciarAutoplay() {
        this.pausarAutoplay();
        this.temporizadorAutoplay = setInterval(() => {
          this.irASlide(this.indiceActual + 1);
        }, this.intervalo);
      }

      pausarAutoplay() {
        if (this.temporizadorAutoplay) {
          clearInterval(this.temporizadorAutoplay);
          this.temporizadorAutoplay = null;
        }
      }

      reiniciarAutoplay() {
        if (this.autoplayActivo && this.totalSlides > 1) {
          this.iniciarAutoplay();
        }
      }

      iniciarObservadorVisibilidad() {
        const activarSiVisible = () => {
          const rect = this.getBoundingClientRect();
          const visible = rect.top < window.innerHeight && rect.bottom > 0;
          if (visible) {
            this.classList.add('seccion-visible');
          }
        };

        activarSiVisible();

        if (!('IntersectionObserver' in window)) {
          this.classList.add('seccion-visible');
          return;
        }

        const observador = new IntersectionObserver((entradas) => {
          entradas.forEach((entrada) => {
            if (entrada.isIntersecting) {
              this.classList.add('seccion-visible');
            } else {
              this.classList.remove('seccion-visible');
            }
          });
        }, {
          threshold: 0,
          rootMargin: '0px 0px -50px 0px'
        });

        observador.observe(this);
      }
    }

    if (!customElements.get('testimonios-artistas')) {
      customElements.define('testimonios-artistas', TestimoniosArtistas);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productos-destacados"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // --- Glow que sigue al cursor -------------------------------------------
    // Cada tarjeta actualiza dos variables CSS (--mx, --my) con la posición
    // del ratón. El halo blanco (::before de la tarjeta) se centra en ese
    // punto. Puro CSS a partir de ahí: sin repintados costosos.
    var tarjetas = document.querySelectorAll('.tarjeta-producto-destacado');

    tarjetas.forEach(function (tarjeta) {
      tarjeta.addEventListener('pointermove', function (e) {
        var rect = tarjeta.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        tarjeta.style.setProperty('--mx', x + '%');
        tarjeta.style.setProperty('--my', y + '%');
      });
    });

    // --- Add to cart por AJAX ------------------------------------------------
    var botones = document.querySelectorAll('.boton-carrito-producto');

    botones.forEach(function (boton) {
      boton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var id = boton.getAttribute('data-variante-id');
        if (!id || boton.classList.contains('is-loading') || boton.classList.contains('is-done')) return;

        boton.classList.add('is-loading');

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart');
            return res.json();
          })
          .then(function () {
            boton.classList.remove('is-loading');
            boton.classList.add('is-done');

            // Refresca el contador del carrito del header sin recargar.
            fetch(window.Shopify.routes.root + 'cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                var contadores = document.querySelectorAll('[data-cart-count]');
                contadores.forEach(function (c) {
                  c.textContent = cart.item_count;
                  c.hidden = cart.item_count === 0;
                });
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
              });

            // Vuelve al estado inicial tras un momento.
            setTimeout(function () { boton.classList.remove('is-done'); }, 1800);
          })
          .catch(function () {
            boton.classList.remove('is-loading');
            boton.classList.add('is-error');
            setTimeout(function () { boton.classList.remove('is-error'); }, 1800);
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-contador"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class EstadisticasContador extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.animacionEjecutada = false;
        this.elementosContadores = this.querySelectorAll('[data-numero-contador]');
        this.iniciarObservador();
      }

      iniciarObservador() {
        const activarSiVisible = () => {
          const rect = this.getBoundingClientRect();
          const visible = rect.top < window.innerHeight && rect.bottom > 0;
          if (visible) {
            this.dispararAnimacion();
          }
        };

        activarSiVisible();

        if (!('IntersectionObserver' in window)) {
          this.dispararAnimacion();
          return;
        }

        const observador = new IntersectionObserver((entradas) => {
          entradas.forEach((entrada) => {
            if (entrada.isIntersecting) {
              this.dispararAnimacion();
            }
          });
        }, {
          threshold: 0.15,
          rootMargin: '0px 0px -50px 0px'
        });

        observador.observe(this);
      }

      dispararAnimacion() {
        if (this.animacionEjecutada) return;
        this.animacionEjecutada = true;
        this.classList.add('seccion-visible');

        this.elementosContadores.forEach((elemento, indice) => {
          const delayBase = indice * 80;
          setTimeout(() => {
            this.animarContador(elemento);
          }, delayBase);
        });
      }

      animarContador(elemento) {
        const objetivo = parseInt(elemento.getAttribute('data-numero-objetivo'), 10);
        const separadorMiles = elemento.getAttribute('data-separador-miles') === 'true';
        if (isNaN(objetivo)) return;

        const duracionTotal = parseInt(getComputedStyle(this).getPropertyValue('--sec-duracion-animacion'), 10) || 1500;
        const tiempoInicio = performance.now();

        const formatearNumero = (valor) => {
          const entero = Math.floor(valor);
          if (separadorMiles && entero >= 1000) {
            return entero.toLocaleString('en-US');
          }
          return entero.toString();
        };

        const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

        const animar = (ahora) => {
          const transcurrido = ahora - tiempoInicio;
          const progreso = Math.min(transcurrido / duracionTotal, 1);
          const progresoEase = easeOutCubic(progreso);
          const valorActual = progresoEase * objetivo;

          elemento.textContent = formatearNumero(valorActual);

          if (progreso < 1) {
            requestAnimationFrame(animar);
          } else {
            elemento.textContent = formatearNumero(objetivo);
          }
        };

        requestAnimationFrame(animar);
      }
    }

    if (!customElements.get('estadisticas-contador')) {
      customElements.define('estadisticas-contador', EstadisticasContador);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selector-generos"] && !Shopify.designMode) return;
  try {
    
  class SelectorGeneros extends HTMLElement {
    connectedCallback() {
      this.pista = this.querySelector('[data-pista-generos]');
      this.capas = Array.from(this.querySelectorAll('[data-capa-fondo]'));
      this.enlaces = Array.from(this.querySelectorAll('[data-enlace-genero]'));
      this.boton = this.querySelector('[data-boton-generos]');
      this.numeroActual = this.querySelector('[data-numero-actual]');
      this.progreso = this.querySelector('[data-progreso-indicador]');

      if (!this.pista || !this.capas.length) return;

      this.total = this.capas.length;
      this.indiceActivo = -1;
      this.pendiente = false;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.alScroll = () => {
        if (this.pendiente) return;
        this.pendiente = true;
        requestAnimationFrame(() => {
          this.actualizar();
          this.pendiente = false;
        });
      };

      window.addEventListener('scroll', this.alScroll, { passive: true });
      window.addEventListener('resize', this.alScroll, { passive: true });
      this.actualizar();
    }

    disconnectedCallback() {
      if (this.alScroll) {
        window.removeEventListener('scroll', this.alScroll);
        window.removeEventListener('resize', this.alScroll);
      }
    }

    actualizar() {
      const rect = this.pista.getBoundingClientRect();
      const recorrido = this.pista.offsetHeight - window.innerHeight;
      if (recorrido <= 0) return;

      /* 0 = primer genero, 1 = ultimo. */
      let avance = -rect.top / recorrido;
      avance = Math.min(1, Math.max(0, avance));

      /* Posicion fraccionaria dentro de la lista: 0 .. total-1 */
      const posicion = avance * (this.total - 1);

      /* Cada capa se desplaza segun su distancia a la posicion actual.
         La siguiente entra desde abajo y empuja a la anterior hacia arriba. */
      this.capas.forEach((capa, i) => {
        let desplazamiento = (i - posicion) * 100;
        if (desplazamiento > 100) desplazamiento = 100;
        if (desplazamiento < -100) desplazamiento = -100;
        capa.style.setProperty('--sgn-desplazamiento', desplazamiento.toFixed(2));
      });

      const indice = Math.min(this.total - 1, Math.max(0, Math.round(posicion)));
      if (indice !== this.indiceActivo) {
        this.indiceActivo = indice;
        this.enlaces.forEach((enlace, i) => {
          enlace.classList.toggle('enlace-genero--activo', i === indice);
        });
        /* El boton sigue al genero que se esta viendo. */
        if (this.boton && this.enlaces[indice]) {
          const destino = this.enlaces[indice].dataset.destino;
          if (destino) this.boton.setAttribute('href', destino);
          const etiqueta = this.enlaces[indice].dataset.etiqueta;
          if (etiqueta) this.boton.setAttribute('aria-label', etiqueta);
        }
        if (this.numeroActual) this.numeroActual.textContent = indice + 1;
      }

      if (this.progreso) {
        this.progreso.style.height = (avance * 100).toFixed(1) + '%';
      }
    }
  }

  if (!customElements.get('selector-generos')) {
    customElements.define('selector-generos', SelectorGeneros);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tarjetas-info"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class TarjetasRelieve extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.iniciarObservadorVisibilidad();
      }

      iniciarObservadorVisibilidad() {
        const activarSiVisible = () => {
          const rect = this.getBoundingClientRect();
          const visible = rect.top < window.innerHeight && rect.bottom > 0;
          if (visible) {
            this.classList.add('seccion-visible');
          }
        };

        activarSiVisible();

        if (!('IntersectionObserver' in window)) {
          this.classList.add('seccion-visible');
          return;
        }

        const observador = new IntersectionObserver((entradas) => {
          entradas.forEach((entrada) => {
            if (entrada.isIntersecting) {
              this.classList.add('seccion-visible');
            }
          });
        }, {
          threshold: 0,
          rootMargin: '0px 0px -50px 0px'
        });

        observador.observe(this);
      }
    }

    if (!customElements.get('tarjetas-relieve')) {
      customElements.define('tarjetas-relieve', TarjetasRelieve);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["texto-rotativo-palabras"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class TextoRotativoPalabras extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.contenedorFijo = this.querySelector('[data-contenedor-fijo]');
        this.fraseWrapper = this.querySelector('[data-frase-wrapper]');
        this.contenedorPalabras = this.querySelector('[data-contenedor-palabras]');
        this.palabraFantasma = this.querySelector('[data-palabra-fantasma]');
        this.palabras = this.querySelectorAll('[data-palabra]');

        if (this.palabras.length === 0) {
          return;
        }

        this.indiceActivo = 0;
        this.frameId = null;

        if (this.prefiereReducirMovimiento()) {
          this.mostrarTodasPalabras();
          return;
        }

        this.ajustarPalabraFantasma();
        this.iniciarObservadorScroll();
        this.escucharResize();
        this.actualizarAnimacion();
      }

      prefiereReducirMovimiento() {
        return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      mostrarTodasPalabras() {
        this.palabras.forEach((palabra) => {
          palabra.classList.add('palabra-activa');
        });
      }

      ajustarPalabraFantasma() {
        if (!this.palabraFantasma) return;

        let textoMasLargo = '';
        let anchoMaximo = 0;

        const medidor = document.createElement('span');
        medidor.style.visibility = 'hidden';
        medidor.style.position = 'absolute';
        medidor.style.whiteSpace = 'nowrap';
        medidor.style.font = window.getComputedStyle(this.palabraFantasma).font;
        document.body.appendChild(medidor);

        this.palabras.forEach((palabra) => {
          medidor.textContent = palabra.textContent;
          const ancho = medidor.offsetWidth;
          if (ancho > anchoMaximo) {
            anchoMaximo = ancho;
            textoMasLargo = palabra.textContent;
          }
        });

        document.body.removeChild(medidor);

        if (textoMasLargo) {
          this.palabraFantasma.textContent = textoMasLargo;
        }
      }

      iniciarObservadorScroll() {
        const onScroll = () => {
          if (this.frameId) return;
          this.frameId = requestAnimationFrame(() => {
            this.actualizarAnimacion();
            this.frameId = null;
          });
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        this.actualizarAnimacion();
      }

      escucharResize() {
        let timeoutResize;
        window.addEventListener('resize', () => {
          clearTimeout(timeoutResize);
          timeoutResize = setTimeout(() => {
            this.ajustarPalabraFantasma();
            this.actualizarAnimacion();
          }, 150);
        });
      }

      actualizarAnimacion() {
        const rect = this.getBoundingClientRect();
        const alturaSeccion = this.offsetHeight;
        const alturaViewport = window.innerHeight;
        const alturaScrolleable = alturaSeccion - alturaViewport;

        const top = rect.top;
        const scrollEnSeccion = -top;

        if (top > 0) {
          this.contenedorFijo.classList.remove('modo-fijo');
          this.contenedorFijo.classList.remove('modo-final');
        } else if (scrollEnSeccion >= alturaScrolleable) {
          this.contenedorFijo.classList.remove('modo-fijo');
          this.contenedorFijo.classList.add('modo-final');
        } else {
          this.contenedorFijo.classList.add('modo-fijo');
          this.contenedorFijo.classList.remove('modo-final');
        }

        let progreso = scrollEnSeccion / alturaScrolleable;
        progreso = Math.max(0, Math.min(1, progreso));

        const totalPalabras = this.palabras.length;
        let indiceNuevo = Math.floor(progreso * totalPalabras);
        if (indiceNuevo >= totalPalabras) {
          indiceNuevo = totalPalabras - 1;
        }

        if (indiceNuevo !== this.indiceActivo) {
          this.cambiarPalabraActiva(indiceNuevo);
        }
      }

      cambiarPalabraActiva(nuevoIndice) {
        this.palabras.forEach((palabra) => {
          const indice = parseInt(palabra.getAttribute('data-indice-palabra'), 10);
          if (indice === nuevoIndice) {
            palabra.classList.add('palabra-activa');
          } else {
            palabra.classList.remove('palabra-activa');
          }
        });

        this.indiceActivo = nuevoIndice;
      }
    }

    if (!customElements.get('texto-rotativo-palabras')) {
      customElements.define('texto-rotativo-palabras', TextoRotativoPalabras);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["titulo-parrafos-about"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class TituloParrafosAbout extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.animacionActivada = this.getAttribute('data-animacion-entrada') === 'true';

        if (!this.animacionActivada) return;
        if (this.prefiereReducirMovimiento()) {
          this.mostrarTodoSinAnimacion();
          return;
        }

        this.titulo = this.querySelector('[data-titulo-about]');
        this.parrafos = this.querySelectorAll('[data-parrafo-about]');
        this.elementosAnimables = [];

        if (this.titulo) {
          this.elementosAnimables.push(this.titulo);
        }
        this.parrafos.forEach((p) => this.elementosAnimables.push(p));

        this.iniciarObservador();
      }

      prefiereReducirMovimiento() {
        return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      mostrarTodoSinAnimacion() {
        const elementos = this.querySelectorAll('[data-titulo-about], [data-parrafo-about]');
        elementos.forEach((el) => el.classList.add('elemento-visible'));
      }

      iniciarObservador() {
        const opciones = {
          threshold: 0.15,
          rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entradas) => {
          entradas.forEach((entrada) => {
            if (entrada.isIntersecting) {
              this.animarElementos();
              observer.disconnect();
            }
          });
        }, opciones);

        observer.observe(this);
      }

      animarElementos() {
        this.elementosAnimables.forEach((elemento, indice) => {
          setTimeout(() => {
            elemento.classList.add('elemento-visible');
          }, indice * 120);
        });
      }
    }

    if (!customElements.get('titulo-parrafos-about')) {
      customElements.define('titulo-parrafos-about', TituloParrafosAbout);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class HeroVideoPersonalizado extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.contenido = this.querySelector('[data-contenido-hero]');
        this.overlay = this.querySelector('[data-overlay-hero]');
        this.video = this.querySelector('video');

        this.iniciar();
        this.escucharVisibilidad();
      }

      iniciar() {
        if (this.video) {
          this.video.muted = true;
          this.video.playsInline = true;
          this.video.setAttribute('playsinline', '');
          this.intentarReproducir();
        }

        const autoarrancar = this.getAttribute('data-autoarrancar') !== 'false';

        if (autoarrancar) {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => this.activarContenido());
          });
        }
      }

      intentarReproducir() {
        if (!this.video) return;
        const promesa = this.video.play();
        if (promesa && typeof promesa.catch === 'function') {
          promesa.catch(() => {
            const reintentar = () => {
              this.video.play().catch(() => {});
              document.removeEventListener('click', reintentar);
              document.removeEventListener('touchstart', reintentar);
            };
            document.addEventListener('click', reintentar, { once: true });
            document.addEventListener('touchstart', reintentar, { once: true });
          });
        }
      }

      activarContenido() {
        if (this.contenido) this.contenido.classList.add('contenido-activo');
        if (this.overlay) this.overlay.classList.add('overlay-activo');
      }

      escucharVisibilidad() {
        if (!this.video) return;
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.video.pause();
          } else {
            this.intentarReproducir();
          }
        });
      }
    }

    if (!customElements.get('hero-video-personalizado')) {
      customElements.define('hero-video-personalizado', HeroVideoPersonalizado);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
